<template>
  <div v-if="isdisplay" :class="['pos3-overlay', isDark ? 'theme-dark' : 'theme-light']">

    <!-- ===== SHELL ===== -->
    <div class="pos3-shell">

      <!-- ── TOPBAR ── -->
      <div class="pos3-topbar">
        <span class="pos3-appname">{{ titlemodal }}</span>

        <div class="pos3-topbar-center">
          <span class="pos3-chip">{{ Items.datedoc }}</span>
          <span v-if="Items.docnum" class="pos3-chip chip-accent">#{{ Items.docnum }}</span>
          <span v-if="waitNumber" class="pos3-chip chip-wait">🎫 {{ waitNumber }}</span>
          <span v-if="compteprocess > 0" class="pos3-chip chip-warn">
                        <i class="ri-loader-4-line pos3-spin"></i> {{ compteprocess }}
                    </span>
        </div>

        <div class="pos3-topbar-right">
          <!-- Toggle dark/light -->
          <button class="pos3-topbtn" @click="toggleTheme" :title="isDark ? 'Mode jour' : 'Mode nuit'">
            <i :class="isDark ? 'ri-sun-line' : 'ri-moon-line'"></i>
          </button>
          <!-- Options -->
          <button class="pos3-topbtn" @click="showOptionsModal = true" title="Options">
            <i class="ri-settings-3-line"></i>
          </button>
          <!-- Fermer -->
          <button class="pos3-topbtn pos3-topbtn-danger" @click="close" title="Fermer">
            <i class="ri-close-line"></i>
          </button>
        </div>
      </div>

      <!-- ── MAIN GRID ── -->
      <div class="pos3-main">

        <!-- ════ LEFT : Catalogue ════ -->
        <div class="pos3-left">
          <!-- Barre recherche + catégories -->
          <div class="pos3-toolbar">
            <div class="pos3-search-wrap">
              
              <i class="ri-search-line pos3-search-icon"></i>
              <input
                  v-model="searchword"
                  type="text"
                  placeholder="Recherche rapide..."
                  ref="modalInput"
                  class="pos3-search"
              />
              <button v-if="searchword" @click="searchword=''" class="pos3-search-clear">
                <i class="ri-close-line"></i>
              </button>
            </div>
            <div class="pos3-cats">
              <button
                  @click="selectedcatalogue = ''"
                  :class="['pos3-cat', { active: selectedcatalogue === '' }]"
              >Tout</button>
              <button
                  v-for="(_, catName) in datatablearticlegroupe"
                  :key="catName"
                  @click="selectedcatalogue = catName"
                  :class="['pos3-cat', { active: selectedcatalogue === catName }]"
              >{{ catName }}</button>
            </div>
          </div>

          <!-- Grille articles -->
          <div class="pos3-items-grid" ref="itemsGrid">
            <div
                v-for="article in visibledatatable"
                :key="article.pid"
                :class="['pos3-item-card', { 'in-order': isInOrder(article), 'low-stock': isLowStock(article) }]"
                @dblclick="selectionitemforfacturation(article)"
                @touchstart="touchStart($event, article)"
                @touchend="touchEnd"
                :title="isLowStock(article) ? 'Stock faible : ' + article.rstck + ' restant(s)' : article.libelle"
            >
              <div v-if="getOrderQty(article) > 0" class="pos3-ic-badge">{{ formatNumber2(getOrderQty(article)) }}</div>
              <div class="pos3-ic-em"><i :class="getCategoryIcon(article.catalogue)"></i></div>
              <div class="pos3-ic-name">{{ article.libelle }}</div>
              <div class="pos3-ic-footer">
                <span class="pos3-ic-price">{{ formatNumber(article.pu) }} F</span>
                <span v-if="article.accompagnement && article.accompagnement.length" class="pos3-ic-tag">+Acc</span>
                <span v-if="hasStockControl(article)"
                      class="pos3-ic-tag tag-stock"
                      :class="{ 'tag-warn': isLowStock(article) }">
                  <i class="ri-stack-line"></i> {{ formatNumber2(article.rstck) }}
                </span>
              </div>
            </div>
            <div v-if="filterdatatable.length === 0" class="pos3-empty-grid">
              <i class="ri-search-line"></i>
              <p>Aucun article</p>
            </div>

            <!-- Sentinelle scroll infini + indicateur de chargement -->
            <div ref="itemsSentinel" class="pos3-scroll-sentinel">
              <div v-if="hasMoreArticles" class="pos3-scroll-loader">
                <i class="ri-loader-4-line pos3-spin"></i> Chargement…
              </div>
            </div>
          </div>
        </div>

        <!-- ════ RIGHT : Commande ════ -->
        <div :class="['pos3-right', { 'mobile-visible': showMobileOrder }]">

          <!-- Entête : Serveur / Table / Client -->
          <div class="pos3-right-top">
            <div class="pos3-rt-row">
              <span class="pos3-rt-lbl">Serveur</span>
              <select v-model="Items.jsonotherdonne.collaborateur"
                      @change="handleServerSelect" class="pos3-rt-sel">
                <option :value="null">-- Serveur --</option>
                <option v-for="(c,i) in otherdatatable.collaborateur" :key="i" :value="c">{{ c.name }}</option>
              </select>
            </div>
            <div class="pos3-rt-row">
              <span class="pos3-rt-lbl">Table</span>
              <select v-model="Items.jsonv.commandetable"
                      @change="handleTableSelect" class="pos3-rt-sel">
                <option :value="null">-- Table --</option>
                <option v-for="(t,i) in otherdatatable.commandetable" :key="i" :value="t">{{ t.name }}</option>
              </select>
            </div>
            <div class="pos3-rt-row">
              <span class="pos3-rt-lbl">Client</span>
              <select v-model="Items.jsonotherdonne.cltfrs"
                      @change="handleClientSelect" class="pos3-rt-sel">
                <option :value="null">-- Client --</option>
                <option v-for="(c,i) in otherdatatable.beneficiairecl" :key="i" :value="c">{{ c.name }}</option>
              </select>
              <button class="pos3-details-btn" @click="showClientDetailsModal = true">
                <i class="ri-user-add-line"></i> Détails
              </button>
            </div>
          </div>

          <!-- Liste articles commandés -->
          <div class="pos3-order-list">
            <div v-if="!listedatatable.length" class="pos3-empty-order">
              <span class="pos3-empty-ico">🧾</span>
              <p>Commande vide<br/><small>Double-cliquez ou touchez un article</small></p>
            </div>
            <div
                v-for="(item, idx) in listedatatable"
                :key="idx"
                :class="['pos3-oi', getOrderItemClass(item)]"
            >
              <span :class="getStatusBadgeClass(item)">{{ getStatusText(item) }}</span>
              <div class="pos3-oi-info">
                <div class="pos3-oi-name">
                  {{ item.article.libelle }}
                  <em v-if="item.autredesignation"> ({{ item.autredesignation }})</em>
                </div>
                <div class="pos3-oi-sub">
                  {{ formatNumber2(item.qtite) }} × {{ item.pu }} F
                  <span v-if="item.remise"> − {{ item.remise }} F</span>
                </div>
                <div v-if="item.etatline === 2" class="pos3-oi-err">
                  <i class="ri-error-warning-line"></i> <span v-html="item.linemessage"></span>
                </div>
              </div>
              <div class="pos3-oi-right">
                <strong class="pos3-oi-total">{{ currencyFormatDE(item.calmtntht) }} F</strong>
                <div class="pos3-oi-btns">
                  <button @click.stop="btnupdateqteitem(item)" class="pos3-mini-btn btn-edit" title="Modifier">
                    <i class="ri-edit-line"></i>
                  </button>
                  <button @click.stop="deleteItemArticle(item)" class="pos3-mini-btn btn-del" title="Supprimer">
                    <i class="ri-delete-bin-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer : totaux + boutons -->
          <div class="pos3-order-footer">
            <div class="pos3-totals">
              <div class="pos3-trow">
                <span>Sous-total</span>
                <span>{{ currencyFormatDE(Items.mtnt.doccalmtnttotalht) }} F</span>
              </div>
              <div v-if="Items.mtnt.docmtntremise > 0" class="pos3-trow">
                <span>Remise</span>
                <span class="text-red">− {{ currencyFormatDE(Items.mtnt.docmtntremise) }} F</span>
              </div>
              <div v-if="Items.mtnt.doctva > 0" class="pos3-trow">
                <span>TVA</span>
                <span>{{ currencyFormatDE(Items.mtnt.doctva) }} F</span>
              </div>
              <div class="pos3-trow pos3-trow-main">
                <span>TOTAL</span>
                <span>{{ currencyFormatDE(Items.mtnt.docmtnttotalttc) }} F</span>
              </div>
            </div>
            <button class="pos3-pause-btn" @click="envoyerCommande" :disabled="!Items.pidindexedb || !listedatatableindexedb.length || compteprocess > 0" title="F9 - Mettre en attente">
              <i class="ri-pause-line"></i> Mise en attente
              <kbd>F9</kbd>
              <span v-if="waitNumber" class="pos3-pause-wait">{{ waitNumber }}</span>
            </button>
            <div class="pos3-print-group">
              <button class="pos3-note-btn" @click="note" :disabled="!listedatatable.length || compteprocess > 0" title="F5 - Imprimer la note">
                <i class="ri-printer-line"></i> Note
                <kbd>F5</kbd>
              </button>
              <div class="pos3-print-subrow">
                <button class="pos3-note-btn pos3-note-cuisine" @click="printBon('cuisine')" :disabled="!listedatatable.length || compteprocess > 0" title="F6 - Bon Cuisine">
                  <i class="ri-restaurant-line"></i> Cuisine
                  <kbd>F6</kbd>
                </button>
                <button class="pos3-note-btn pos3-note-bar" @click="printBon('bar')" :disabled="!listedatatable.length || compteprocess > 0" title="F7 - Bon Bar">
                  <i class="ri-drink-line"></i> Bar
                  <kbd>F7</kbd>
                </button>
                <button class="pos3-note-btn pos3-note-caisse" @click="newinvoice"   title="F10 - Nouveau">
                  <i class="ri-add-line"></i> Nouveau
                  <kbd>F10</kbd>
                </button>
 

              </div>
            </div>
            <button
                class="pos3-cpt-btn"
                @click="openComptabilisationModal"
                :disabled="compteprocess > 0 || parseFloat(Items.mtnt.docmtnttotalttc || 0) === 0"
                :class="{ disabled: compteprocess > 0 || parseFloat(Items.mtnt.docmtnttotalttc || 0) === 0 }"
            >
              <i class="ri-check-double-line"></i>
              Comptabiliser
              <span v-if="compteprocess > 0">({{ compteprocess }})</span>
            </button>
          </div>
        </div>
      </div><!-- /pos3-main -->

      <!-- ── BARRE MOBILE BAS ── (visible uniquement sur mobile) -->
      <div class="pos3-mobile-bar">
        <div class="pos3-mobile-total">
          <span>{{ listedatatable.length }} art. -</span>
          <strong>{{ currencyFormatDE(Items.mtnt.docmtnttotalttc) }} F</strong>
        </div>
        <button class="pos3-mobile-toggle" @click="showMobileOrder = !showMobileOrder">
          <i :class="showMobileOrder ? 'ri-store-2-line' : 'ri-shopping-cart-line'"></i>
          {{ showMobileOrder ? 'Articles' : 'Commande' }}
          <span v-if="listedatatable.length && !showMobileOrder" class="pos3-mb-badge">{{ listedatatable.length }}</span>
        </button>
      </div>

    </div><!-- /pos3-shell -->

    <!-- ═══════ FAB FLOTTANTS ═══════ -->
    <div class="pos3-fab-group">
      <!-- Trigger principal -->
      <button
          :class="['pos3-fab-trigger', { open: fabOpen }]"
          @click="fabOpen = !fabOpen"
          title="Actions"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
          <circle cx="12" cy="5"  r="1.2" fill="currentColor" stroke="none"/>
          <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none"/>
          <circle cx="12" cy="19" r="1.2" fill="currentColor" stroke="none"/>
        </svg>
      </button>

      <!-- Enfants FAB -->
      <transition-group name="fab-pop" tag="div" class="pos3-fab-children" v-show="fabOpen">

        <!-- Factures en attente -->
        <button key="pending" class="pos3-fab-item fab-blue" @click="btnupdatefactureselected(); fabOpen=false" title="Factures en attente">
          <i class="ri-file-list-line"></i>
          <span v-if="nbrefactureenattante > 0" class="pos3-fab-badge">{{ nbrefactureenattante }}</span>
          <span class="pos3-fab-tip">Factures en attente</span>
        </button>

        <!-- Imprimer note -->
        <button key="note" class="pos3-fab-item fab-amber" @click="note(); fabOpen=false"
                :disabled="!listedatatable.length" title="Imprimer note (F5)">
          <i class="ri-printer-line"></i>
          <span class="pos3-fab-tip">Note (F5)</span>
        </button>

        <!-- Bon Cuisine -->
        <button key="cuisine" class="pos3-fab-item fab-amber" @click="printBon('cuisine'); fabOpen=false"
                :disabled="!listedatatable.length" title="Bon Cuisine (F6)">
          <i class="ri-restaurant-line"></i>
          <span class="pos3-fab-tip">Cuisine (F6)</span>
        </button>

        <!-- Bon Bar -->
        <button key="bar" class="pos3-fab-item fab-amber" @click="printBon('bar'); fabOpen=false"
                :disabled="!listedatatable.length" title="Bon Bar (F7)">
          <i class="ri-drink-line"></i>
          <span class="pos3-fab-tip">Bar (F7)</span>
        </button>

        <!-- Bon Caisse -->
        <button key="caisse" class="pos3-fab-item fab-amber" @click="printBon('caisse'); fabOpen=false"
                :disabled="!listedatatable.length" title="Bon Caisse (F8)">
          <i class="ri-bill-line"></i>
          <span class="pos3-fab-tip">Caisse (F8)</span>
        </button>

        <!-- Mettre en attente -->
        <button key="pause" v-if="Items.pidindexedb" class="pos3-fab-item fab-purple"
                @click="envoyerCommande(); fabOpen=false"
                :disabled="compteprocess > 0 || !listedatatableindexedb.length" title="Mettre en attente (F9)">
          <i class="ri-pause-line"></i>
          <span class="pos3-fab-tip">Mettre en attente</span>
        </button>

        <!-- Nouveau -->
        <button key="nouveau" class="pos3-fab-item fab-red" @click="newinvoice(); fabOpen=false" title="Nouvelle commande (F10)">
          <i class="ri-add-line"></i>
          <span class="pos3-fab-tip">Nouveau (F10)</span>
        </button>

        <!-- Options -->
        <button key="options" class="pos3-fab-item fab-slate" @click="showOptionsModal=true; fabOpen=false" title="Options">
          <i class="ri-settings-3-line"></i>
          <span class="pos3-fab-tip">Options</span>
        </button>

        <!-- Comptabiliser (accès rapide mobile) -->
        <button key="cpt" class="pos3-fab-item fab-green"
                @click="openComptabilisationModal(); fabOpen=false"
                :disabled="compteprocess > 0 || parseFloat(Items.mtnt.docmtnttotalttc || 0) === 0"
                title="Comptabiliser">
          <i class="ri-check-double-line"></i>
          <span class="pos3-fab-tip">Comptabiliser</span>
        </button>

        <!-- Synchroniser articles -->
        <button key="note" class="pos3-fab-item fab-blue" @click="handlebtnreinitialiserAllarticle(); fabOpen=false"
              title="Synchroniser articles">
          <i  style="color: white;"  class="ri-refresh-line text-blue-500"></i>
          <span class="pos3-fab-tip">Synchroniser articles</span>
        </button>





      </transition-group>
    </div>

    <!-- ═══════ MODAL : Détails client ═══════ -->
    <div v-if="showClientDetailsModal" class="pos3-modal-overlay" @click.self="showClientDetailsModal = false">
      <div class="pos3-modal">
        <div class="pos3-modal-head">
          <span><i class="ri-user-line"></i> Détails client</span>
          <button @click="showClientDetailsModal = false"><i class="ri-close-line"></i></button>
        </div>
        <div class="pos3-modal-body">
          <label class="pos3-lbl">Nom du client</label>
          <input v-model="Items.jsonv.client" class="pos3-input" placeholder="Nom complet" />

          <label class="pos3-lbl">IFU</label>
          <input v-model="Items.jsonv.ifu" class="pos3-input" placeholder="Numéro IFU" />

          <label class="pos3-lbl">Téléphone</label>
          <input v-model="Items.jsonv.telephone" class="pos3-input" placeholder="+229 XX XX XX XX" type="tel" />
        </div>
        <div class="pos3-modal-foot">
          <button class="pos3-btn-sec" @click="showClientDetailsModal = false">Annuler</button>
          <button class="pos3-btn-pri" @click="showClientDetailsModal = false">
            <i class="ri-check-line"></i> Valider
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════ MODAL : Comptabilisation ═══════ -->
    <div v-if="showComptabilisationModal" class="pos3-modal-overlay" @click.self="showComptabilisationModal = false">
      <div class="pos3-modal pos3-modal-lg">
        <div class="pos3-modal-head">
          <span><i class="ri-money-euro-circle-line"></i> Règlement - {{ currencyFormatDE(Items.mtnt.docmtnttotalttc) }} F</span>
          <button @click="showComptabilisationModal = false"><i class="ri-close-line"></i></button>
        </div>
        <div class="pos3-modal-body">

          <!-- Modes de règlement -->
          <label class="pos3-lbl">Mode de règlement</label>
          <div class="pos3-pay-grid">
            <button
                v-for="(m,i) in otherdatatable.modedereglement" :key="i"
                @click="selectPaymentMethod(m)"
                :class="['pos3-pay-btn', { selected: Items.jsonv.modereglement && Items.jsonv.modereglement.pid === m.pid }]"
            >
              <i class="ri-bank-card-line"></i><br/>{{ m.name }}
            </button>
          </div>

          <!-- Montant reçu -->
          <label class="pos3-lbl">Montant reçu</label>
          <div class="pos3-amount-row">
            <input
                v-model="Items.jsonotherdonne.montantrecu"
                type="number" min="0"
                class="pos3-input pos3-input-lg"
                :placeholder="String(Items.mtnt.docmtnttotalttc)"
            />
            <span class="pos3-currency-lbl">FCFA</span>
          </div>

          <!-- Monnaie -->
          <div v-if="Items.jsonotherdonne.montantrecu > 0" class="pos3-change-box">
            <span>Monnaie à rendre</span>
            <strong :class="parseFloat(reliquat) < 0 ? 'text-red' : 'text-green'">
              {{ reliquat }} F
            </strong>
          </div>

          <!-- Montants rapides -->
          <div v-if="Items.mtnt.docmtnttotalttc > 0" class="pos3-quick">
            <button v-for="amt in [500,1000,2000,5000,10000,20000,50000]" :key="amt"
                    @click="Items.jsonotherdonne.montantrecu = amt" class="pos3-quick-btn">
              {{ formatNumber(amt) }}
            </button>
            <button class="pos3-quick-btn quick-exact"
                    @click="Items.jsonotherdonne.montantrecu = Items.mtnt.docmtnttotalttc">
              Exact
            </button>
          </div>

        </div>
        <div class="pos3-modal-foot">
          <button class="pos3-btn-sec" @click="showComptabilisationModal = false">Annuler</button>
          <button class="pos3-btn-pri" @click="doSaveItems"
                  :disabled="!Items.jsonv.modereglement"
                  :class="{ disabled: !Items.jsonv.modereglement }">
            <i class="ri-check-double-line"></i> Valider la vente
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════ MODAL : Options ═══════ -->
    <div v-if="showOptionsModal" class="pos3-modal-overlay" @click.self="showOptionsModal = false">
      <div class="pos3-modal">
        <div class="pos3-modal-head">
          <span><i class="ri-settings-3-line"></i> Options</span>
          <button @click="showOptionsModal = false"><i class="ri-close-line"></i></button>
        </div>
        <div class="pos3-modal-body">
          <button @click="resetConfig(); showOptionsModal = false" class="pos3-opt-danger">
            <i class="ri-delete-row"></i> Réinitialiser la configuration d'impression
          </button>
        </div>
        <div class="pos3-modal-foot">
          <button class="pos3-btn-sec" @click="showOptionsModal = false">Fermer</button>
        </div>
      </div>
    </div>

    <!-- ═══ AVERTISSEMENT COMMANDE EN COURS ═══ -->
    <div v-if="showPendingWarning" class="pos3-modal-overlay" @click.self="showPendingWarning = false">
      <div class="pos3-modal pos3-pending-dialog">
        <div class="pos3-modal-head">
          <span><i class="ri-alert-line"></i> Commande en cours</span>
          <button @click="showPendingWarning = false"><i class="ri-close-line"></i></button>
        </div>
        <div class="pos3-modal-body pos3-pending-body">
          <p class="pos3-pending-msg">
            Une commande est en cours <strong>({{ Items.pidindexedb || '-' }})</strong>.<br/>
            Que souhaitez-vous faire avant de charger une commande en attente ?
          </p>
          <div class="pos3-pending-actions">
            <button class="pos3-pending-btn pos3-pending-pause" @click="onPendingMiseEnAttente">
              <i class="ri-pause-circle-line"></i>
              <span>Mettre en attente</span>
              <small>Sauvegarder et continuer</small>
            </button>
            <button class="pos3-pending-btn pos3-pending-new" @click="onPendingNouveau">
              <i class="ri-add-circle-line"></i>
              <span>Nouvelle commande</span>
              <small>Abandonner la commande en cours</small>
            </button>
          </div>
        </div>
        <div class="pos3-modal-foot">
          <button class="pos3-btn-sec" @click="showPendingWarning = false">Annuler</button>
        </div>
      </div>
    </div>

    <!-- Modals enfants -->
    <modalentetecommande    ref="modalentetecommande"    @updateentetecommande="updateentetecommande" />
    <modalselectprice       ref="modalselectprice"       @chekprice="checkprice" />
    <modalaccompagnement    ref="modalaccompagnement"    @selectaccompagnement="checkaccompagnement" />
    <modalmodifierquantite  ref="modalmodifierquantite"  @updateqteitem="updateqteitem" />
    <modalfactureenattente  ref="modalfactureenattente"  @selectedfacture="updatefactureselected" />
    <modalfacturecomptoirepost ref="modalfacturecomptoirepost" @closed="closeimpression" />
  </div>
</template>

<script>
import {inject} from "vue";

const axios = require('axios');
import { mapGetters } from "vuex";
import {
   cloneobjet, currencyFormatDE,
  FormatNumber, groupByKey, isset, randomString
} from "@/allfunction";
import modalselectprice        from "@/components/views/pages/caisse/facturation/2/modal_selectprice";
import modalaccompagnement     from "@/components/views/pages/caisse/facturation/2/modal_accompagnement";
import modalentetecommande     from "@/components/views/pages/caisse/facturation/2/modal_entete";
import modalmodifierquantite   from "@/components/views/pages/caisse/facturation/2/modal_modifierquantite";
import modalfactureenattente   from "@/components/views/pages/caisse/facturation/2/modal_factureenattente_v2";
import modalfacturecomptoirepost from "@/components/views/pages/caisse/rapport/modal_facturecomptoirepost";
import * as JwtService from "@/common/jwt.service";
import qrcodetoimage from "qrcode";
import { 
  getNextTicketKey, numeroAffiche, addToQueue, updateQueueData,
  markQueueFailed, markQueuePending, markQueueCompleted,
  cleanExpiredOrders, incrementPrintCounter, removePrintCounter,
  getQueueCount,_autoCleanCompleted
} from "@/service/orderQueueService";

export default {
  /* eslint-disable */
  name: "formcaisse2",

  watch: {
    searchword(v) { this.page = 1; this.resetInfiniteScroll(); },
    selectedcatalogue() { this.resetInfiniteScroll(); }
  },

  computed: {
    ...mapGetters(['listedesarticlespourlacaisse', 'myscreenSize']),

    datatablearticlegroupe() {
      return groupByKey(this.listedesarticlespourlacaisse, 'catalogue');
    },
    datatablearticle() {
      return this.listedesarticlespourlacaisse;
    },

    /* Index O(1) pid → position dans le catalogue, en remplacement des
       array_search O(n) sur ~3000 articles (ajout/suppression/sync de stock).
       Mis en cache par Vue : reconstruit UNIQUEMENT quand la liste change de
       référence (re-sync catalogue), PAS quand rstck est muté (la mutation en
       place ne déplace pas les index). Première occurrence retenue, comme
       array_search (=== / findIndex). */
    stockIndexByPid() {
      const map = new Map();
      const list = this.datatablearticle || [];
      for (let i = 0; i < list.length; i++) {
        const a = list[i];
        if (a && a.pid !== undefined && a.pid !== null && !map.has(a.pid)) {
          map.set(a.pid, i);
        }
      }
      return map;
    },

    //nbrefactureenattante() { return this.datatable.length; },

    filterdatatable() {
      let mvalue = [];
      this.perPage = this.DefaultperPage;
      for (let [index, datavalue] of Object.entries(this.datatablearticlegroupe)) {
        if (this.selectedcatalogue === '' || index.toLowerCase() === this.selectedcatalogue.toLowerCase()) {
          for (let line of datavalue) { mvalue.push(line); }
        }
      }
      if (this.searchword !== '') {
        const kw = this.searchword.toLowerCase();
        mvalue = mvalue.filter(p => p.libelle.toLowerCase().includes(kw));
      }
      return mvalue;
    },

    /* Scroll infini : seules `visibleCount` cartes sont montées dans le DOM.
       filterdatatable reste la liste filtrée complète ; le stock (rstck) est
       toujours lu en direct sur les objets, jamais figé ici. */
    visibledatatable() {
      return this.filterdatatable.slice(0, this.visibleCount);
    },
    hasMoreArticles() {
      return this.visibleCount < this.filterdatatable.length;
    },

    montant() {
      let m = 0;
      if (this.ItemsArticle.article !== null) {
        if (this.ItemsArticle.qtite !== 0)
          m = parseFloat(this.ItemsArticle.pu) * parseFloat(this.ItemsArticle.qtite);
        if (isNaN(this.ItemsArticle.remise)) this.ItemsArticle.remise = 0;
        if (this.ItemsArticle.remise !== 0 && !isNaN(this.ItemsArticle.remise))
          m -= parseFloat(this.ItemsArticle.remise);
      } else { this.ItemsArticle.pu = 0; }
      return Math.round(m);
    },

    reliquat() {
      return this.calculMonnaie(this.Items.mtnt.docmtnttotalttc, this.Items.jsonotherdonne.montantrecu);
    },
  },

  components: {
    modalselectprice, modalaccompagnement, modalentetecommande,
    modalmodifierquantite, modalfactureenattente, modalfacturecomptoirepost,
  },

  data() {
    return {
      /* UI state */
      isDark: true,
      fabOpen: false,
      showMobileOrder: false,
      showClientDetailsModal: false,
      showComptabilisationModal: false,
      showOptionsModal: false,
      showPendingWarning: false,
      pendingAction: null,

      /* form state */
      isNormalisationEtat: false,
      isdisplay: false,
      titlemodal: "",
      datatable: [],
      otherdatatable: {},
      listedatatable: [],
      listedatatableindexedb: [],
      typedoc: "",
      messageerror: "",
      messagesucces: "",
      compteprocess: 0,
      nbrefactureenattante: 0,
      selectedcatalogue: "",
      waitNumber: "",
      isSaving: false,
      isSelectarticledlclik: false,

      ItemsArticle: {
        accompagnement: [], autredesignation: '', mycheckkey: '', docnum: '',
        article: null, qtite: 0, diqte: 0, pu: 0, pa: 0, mtnt: 0, mtntclt: 0,
        remise: 0, doc: '', docpid: '', docnumother: '', docmag: '', doctp: '',
        linekey: '', calmtntht: 0, etatline: 0, pid: ''
      },

      Items: {},
      defaultclient:null,

      searchword: "",
      page: 1, perPage: 4, Defaultpage: 1, DefaultperPage: 4, pages: [],
      visibleCount: 20,      // scroll infini : nb de cartes montées dans le DOM
      articleChunk: 20,      // taille d'un lot de chargement
      touchTimer: null,
    };
  },

  methods: {

     toggleTheme() {

 

                if (this.listedatatable.length > 0) return;
                this.isDark = !this.isDark;
                this.isNormalisationEtat = !this.isDark;
                if (this.Items.jsonv) {
                    this.Items.jsonv.isnormalisationetat = this.isNormalisationEtat;
                }
            },

    /* ══════════ Scroll infini (chargement par lots de 20) ══════════ */
    resetInfiniteScroll() {
      this.visibleCount = this.articleChunk;
      this.$nextTick(() => {
        const g = this.$refs.itemsGrid;
        if (g) g.scrollTop = 0;
        this.fillViewport();
      });
    },

    loadMoreArticles() {
      if (this.visibleCount >= this.filterdatatable.length) return;
      this.visibleCount += this.articleChunk;
      this.$nextTick(this.fillViewport);
    },

    /* Tant que la grille n'est pas assez remplie pour défiler, on charge le lot
       suivant : sinon la sentinelle resterait visible sans ressortir puis rentrer
       dans le champ de l'observer (donc plus aucun déclenchement). */
    fillViewport() {
      const g = this.$refs.itemsGrid;
      if (!g) return;
      if (g.scrollHeight <= g.clientHeight && this.visibleCount < this.filterdatatable.length) {
        this.loadMoreArticles();
      }
    },

    setupInfiniteScroll() {
      this.teardownInfiniteScroll();
      const sentinel = this.$refs.itemsSentinel;
      const root = this.$refs.itemsGrid;
      if (!sentinel || !root || typeof IntersectionObserver === 'undefined') return;
      this._articlesObserver = new IntersectionObserver((entries) => {
        if (entries[0] && entries[0].isIntersecting) this.loadMoreArticles();
      }, { root, rootMargin: '200px', threshold: 0 });
      this._articlesObserver.observe(sentinel);
    },

    teardownInfiniteScroll() {
      if (this._articlesObserver) {
        this._articlesObserver.disconnect();
        this._articlesObserver = null;
      }
    },

    /* Position O(1) d'un article dans le catalogue via l'index Map.
       Retourne -1 si absent, exactement comme array_search. */
    stockIdxOf(pid) {
      const i = this.stockIndexByPid.get(pid);
      return i === undefined ? -1 : i;
    },

    /* ── helpers affichage ── */
    isInOrder(article) {
      return this.listedatatable.some(i => i.article && i.article.pid === article.pid && i.etatline !== 2);
    },
    getOrderQty(article) {
      return this.listedatatable
          .filter(i => i.article && i.article.pid === article.pid && i.etatline !== 2)
          .reduce((s, i) => s + parseFloat(i.qtite || 0), 0);
    },
    getCategoryIcon(cat) {
      const m = { 'Boissons':'ri-drink-line','Entrées':'ri-bowl-line','Plats':'ri-restaurant-line',
        'Desserts':'ri-cake-line','Menu':'ri-list-check','Spécialités':'ri-star-line',
        'Grillades':'ri-fire-line','Accompagnements':'ri-leaf-line' };
      return m[cat] || 'ri-apps-line';
    },
    getStatusBadgeClass(item) {
      const s = parseInt(item.etatline);
      return s === 1 ? 'pos3-st-ok' : (s === 2 || s === 4) ? 'pos3-st-err' : 'pos3-st-wait';
    },
    getStatusText(item) {
      const s = parseInt(item.etatline);
      return s === 1 ? 'OK' : (s === 2 || s === 4) ? 'Err' : '…';
    },
    getOrderItemClass(item) {
      const s = parseInt(item.etatline);
      return s === 2 || s === 4 ? 'oi-err' : s === 0 ? 'oi-wait' : '';
    },
    isLowStock(article) {
 
      if (parseFloat(article.instock) === 0 ) return false;
      if (article.rstck === null || article.rstck === undefined || isNaN(parseFloat(article.rstck))) return false;
      const rstck = parseFloat(article.rstck);
      if (rstck < 0) return true;
      const stockmin = article.stockminimum !== null && article.stockminimum !== undefined && !isNaN(parseFloat(article.stockminimum))
        ? parseFloat(article.stockminimum) : null;
      if (stockmin !== null) {
        return rstck <= stockmin;
      }
      return rstck < 5;
    },
    getLowStockLabel(article) {
      return 'Stock faible : ' + article.rstck + ' restant(s)';
    },
    /* Stock géré pour cet article (contrôle de stock actif) - comme en v6. */
    hasStockControl(article) {
      return parseInt(article.instock) === 1;
    },

    /* ── touch ── */
    touchStart(e, article) {
      /*if(this.isSelectarticledlclik) return;
      this.touchTimer = setTimeout(() => this.selectionitemforfacturation(article), 500);*/
    },
    touchEnd() {
     /* if (this.touchTimer) { clearTimeout(this.touchTimer); this.touchTimer = null;
      }*/
    },

    /* ── serveur / table / client ── */
    handleServerSelect() {
      if (this.Items.jsonotherdonne.collaborateur)
        this.Items.jsonv.collaborateur = this.Items.jsonotherdonne.collaborateur;
    },
    handleTableSelect() {
      this.Items.jsonotherdonne.commandetable = this.Items.jsonv.commandetable;
    },
    handleClientSelect() {
      if (this.Items.jsonotherdonne.cltfrs) {
        this.Items.jsonv.client = this.Items.jsonotherdonne.cltfrs.name;
        this.Items.jsonv.ifu   = this.Items.jsonotherdonne.cltfrs.ifu;

        this.defaultclient=this.Items.jsonotherdonne.cltfrs


        const modeReglement = this.otherdatatable?.modedereglement?.[0] || null;
        this.Items.jsonv.modereglement = modeReglement;
        this.Items.jsonotherdonne.moderglt = modeReglement;

      }
      else{
        this.Items.jsonv.client = "";
        this.Items.jsonv.ifu   = "";

        this.defaultclient=null
      }
    },

    /* Pré-sélectionne le premier client à l'ouverture, pour éviter au caissier
       de le choisir à chaque fois. Garde-fous :
       - n'écrase JAMAIS un client déjà sélectionné ;
       - ne fait rien si la liste n'est pas (encore) chargée ou est vide.
       handleClientSelect() renseigne au passage nom + IFU + mode de règlement,
       et mémorise defaultclient (réutilisé après impression d'une facture). */
    appliquerClientParDefaut() {
      if (!this.Items || !this.Items.jsonotherdonne) return;
      if (this.Items.jsonotherdonne.cltfrs) return;
      const clients = this.otherdatatable && this.otherdatatable.beneficiairecl;
      if (!Array.isArray(clients) || clients.length === 0) return;
      this.Items.jsonotherdonne.cltfrs = clients[0];
      this.handleClientSelect();
    },

    /* ── comptabilisation ── */
    openComptabilisationModal() {
      if (parseFloat(this.Items.mtnt.docmtnttotalttc) === 0) {
        toastr['error']('Ajoutez au moins un article.', '<b></b>'); return;
      }
      this.showComptabilisationModal = true;
    },
    selectPaymentMethod(m) {
      this.Items.jsonv.modereglement    = m;
      this.Items.jsonotherdonne.moderglt = m;
    },
    async doSaveItems() {
      if (!this.Items.jsonv.modereglement) {
        toastr['error']('Choisissez un mode de règlement.', '<b></b>');
        return;
      }
      this.showComptabilisationModal = false;

      const hasPendingChanges = this.listedatatableindexedb.length > 0;
      const isOnServer = !!(this.Items.docpid && this.Items.docnum);

      if (!hasPendingChanges && !isOnServer) {
        toastr['error']('Veuillez d\'abord envoyer la commande avant de comptabiliser.', '<b></b>');
        return;
      }

      if (hasPendingChanges) {
        await this.envoyerCommande('', '', true);
        if (this.listedatatableindexedb.length > 0) return;
      }

      await this.saveItems();
    },

    /* ── options ── */
    resetConfig() {
      if (confirm('Réinitialiser la configuration d\'impression ?')) {
        this.$refs.modalfacturecomptoirepost.resetToDefaults('note');
        this.$refs.modalfacturecomptoirepost.resetToDefaults('facture');
        toastr['success']('Configuration réinitialisée.');
      }
    },

    /* ── calculs ── */
    calculSomme(p1, p2, p3) { return currencyFormatDE(parseFloat(p1) + parseFloat(p2) + parseFloat(p3)); },
    calculMonnaie(p1, p2)   { return currencyFormatDE(parseFloat(p2) - parseFloat(p1)); },

    /* ── note / impression ── */
    note() {
      if (!this.listedatatable.length) return;

      if (this.listedatatableindexedb.length > 0) {
        this.envoyerCommande('', '', true);
      }

      const items = this.listedatatable.filter(l => l.etatline !== 2);
      const tabvalue = this._buildPrintTabvalue(items, 'note', 0);
      this.$refs.modalfacturecomptoirepost.show(tabvalue, 'note');
    },

    async printBon(type) {
      if (!this.listedatatable.length) return;
      const validItems = this.listedatatable.filter(l => l.etatline !== 2);
      let items;
      if (type === 'bar') {
        items = validItems.filter(i => i.article && i.article.catalogue === 'Boissons');
      } else if (type === 'cuisine') {
        items = validItems.filter(i => i.article && i.article.catalogue !== 'Boissons');
      } else {
        items = validItems;
      }
      if (!items.length) {
        toastr['warning']('Aucun article à imprimer pour ce bon.', '<b></b>'); return;
      }
      const docnum = this.Items.docnum || 'Nouveau';
      let counter = 1;
      try {
        counter = await incrementPrintCounter(docnum, type);
      } catch(e) {}
      const tabvalue = this._buildPrintTabvalue(items, type, counter);
      this.$refs.modalfacturecomptoirepost.show(tabvalue, type);
    },
    _buildPrintTabvalue(items, type, counter) {
      const typeLabel = { note: 'Note', cuisine: 'Bon Cuisine', bar: 'Bon Bar', caisse: 'Bon Caisse' };
      const docnum = this.Items.docnum || '';
      let printNum = docnum ? '#' + docnum : '';
      if (type !== 'note' && counter > 0) {
        const prefix = { cuisine: 'CUIS', bar: 'BAR', caisse: 'CAIS' };
        printNum = docnum ? '#' + docnum + ' / ' + (prefix[type] || type.toUpperCase()) + '-' + String(counter).padStart(3, '0') : '';
      }
      const tabvalue = {
        numdoc: docnum, date: this.Items.datedoc,
        client: this.Items.jsonv.client, ifu: this.Items.jsonv.ifu,
        params: '', params4: '', boutique: '',
        serveur: this.Items.jsonv.collaborateur ? this.Items.jsonv.collaborateur.name : '',
        commandetable: this.Items.jsonv.commandetable ? this.Items.jsonv.commandetable.name : '',
        vendeur: this.$store.state.appusername, items,
        montantht: this.calculSomme(this.Items.mtnt.docmtnttotalht, this.Items.mtnt.docmtntremise, 0),
        montanttva: 0,
        montantremise: currencyFormatDE(this.Items.mtnt.docmtntremise),
        montantnetapayer: this.Items.mtnt.docmtnttotalttc,
        reglement: this.Items.jsonotherdonne.montantrecu,
        montantmonnaie: 0, pourcentageprisenecharge: 0,
        docsaisiepar: this.$store.state.appusername,
        normalise:'', mecefsignature:'', mecefnim:'', mecefcompteur:'', mecefheure:'', mecefqrr:'',
        printType: type, printNum,
      };
      if (this.Items.jsonv.param !== null) tabvalue.params = this.Items.jsonv.param.name;
      return tabvalue;
    },
    async closeimpression(element) {
      if (element !== 'note' && element === 'facture') {
        try { removePrintCounter(this.Items.docnum || ''); } catch(e) {}
        this.newinvoice();
        ///this.load(); 
        await getQueueCount().then(count => {
          if (count > 0) {
            toastr['info'](`Il y a ${count} commande(s) en attente d'envoi.`, '<b></b>');

            this.nbrefactureenattante = count;
          }
        });

        this.Items.jsonotherdonne.cltfrs= this.defaultclient
        this.handleClientSelect();
      }
    },
    btnupdatefactureselected() {
      const hasActiveOrder = !!this.Items.pidindexedb || this.listedatatableindexedb.length > 0;
      if (!hasActiveOrder) {
        this.$refs.modalfactureenattente.show();
        return;
      }
      // Commande en cours → stocker l'action et avertir
      this.pendingAction = () => this.$refs.modalfactureenattente.show();
      this.showPendingWarning = true;
    },

    async onPendingMiseEnAttente() {
      this.showPendingWarning = false;
       //this.$store.dispatch('lancerchargement',true)
      await this.envoyerCommande();
      // this.$store.dispatch('lancerchargement',false)
      this._executePending();
    },

    onPendingNouveau() {
      this.showPendingWarning = false;
      this.newinvoice();
      this._executePending();
    },

    _executePending() {
      if (this.pendingAction) {
        this.$nextTick(() => {
          this.pendingAction();
          this.pendingAction = null;
        });
      }
    },
    btnupdateqteitem(d)        { this.$refs.modalmodifierquantite.show(cloneobjet(d)); },

    /* ── gestion articles ── */
    checkmycheckkey($k) {
      if (!this.listedatatable.length) return {};
      const found = this.listedatatable.find(a => a.mycheckkey === $k);
      if (!found) return {};
      return {
        linekey: found.linekey, etatline: found.etatline, calmtntht: found.calmtntht,
        accompagnement: found.accompagnement, 
        mycheckkey: found.mycheckkey,
        article: found.article, qtite: found.qtite, diqte: 0, pu: found.ppu, pa: found.pa,
        mtnt: found.mtnt, docnumother: "", remise: found.remise,
        autredesignation: found.autredesignation, doctp: found.doctyp,
        pid: found.pid, docpid: found.docnum, docnum: found.docnum
      };
    },
    updateqteitem($d) {
      this.ItemsArticle = $d.item;
      this.ItemsArticle.qtite = $d.newqte;
      this.ItemsArticle.mtnt  = this.montant;
      this.SaveArticle();
    },
    async updatefactureselected($d) {
      const t = this;

      // Branche locale : restauration depuis IndexedDB
      if ($d.source === 'local' && $d.orderData) {
        const od = $d.orderData;
        t.Items = od.Items || t._blankItems();
        t.Items.pidindexedb = od.pidindexedb || t.Items.pidindexedb;
        t.listedatatable = od.listedatatable || [];
        t.listedatatableindexedb = od.listedatatableindexedb || [];
        t.waitNumber = numeroAffiche($d.localId || '');

            t.Items.jsonv.isnormalisationetat=t.isNormalisationEtat
              t.Items.jsonotherdonne.montantrecu = 0;
              t.ItemsArticle.docnum = t.Items.numdoc;
               t.Items.docnum = t.Items.numdoc;
              t.Items.docpid = t.Items.pid; 
              t.ItemsArticle.docnum = t.Items.pid;
              t.ItemsArticle.docpid = t.Items.pid; 
              t.Items.jsonotherdonne.mtypprixdevente = 'prixvente';
 

       /* t.ItemsArticle = t.ItemsArticle || {
          accompagnement:[], autredesignation:'', mycheckkey:'', docnum:'',
          article:null, qtite:0, diqte:0, pu:0, pa:0, mtnt:0, mtntclt:0,
          remise:0, doc:'', docpid:'', docnumother:'', docmag:'', doctp:'',
          linekey:'', calmtntht:0, etatline:0, pid:''
        };*/
        // Met a jour les stocks locaux depuis les donnees restaurees
        //t.listedatatableindexedb.forEach(l => { l.etatline = 0; });
        t.calcullistedatatable();
        return;
      }
/*
      // Branche serveur : appel API pour recuperer les lignes
      const value = $d.item;
      t.Items = {};
      t.Items.jsonotherdonne = {};
      t.$store.dispatch('lancerchargement', true);
      const url = process.env.VUE_APP_API_URL + '/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/' + value.pid + '/' + this.$store.state.appsociete + '/allline895418init51comptoirerefdepdpcc11515/option2/' + randomString(280);
      await axios.get(url, { headers: this._headers(), withCredentials: true })
          .then(res => {
            if (res.data.success) {
              t.Items = value;
              t.Items.jsonotherdonne.montantrecu = 0;
              t.ItemsArticle.docnum = value.numdoc; t.Items.docnum = value.numdoc;
              t.Items.docpid = value.pid; t.ItemsArticle.docnum = value.pid;
              t.ItemsArticle.docpid = value.pid; t.Items.pid = value.pid;
              t.listedatatable = res.data.m;
              t.listedatatableindexedb = [];
              t.Items.pidindexedb = 'resume_' + value.pid;
              t.waitNumber = '';
              t.calcullistedatatable();
              t.Items.jsonotherdonne.mtypprixdevente = 'prixvente';
            }
          })
          .catch(() => {})
          .finally(() => t.$store.dispatch('lancerchargement', false));*/
    },
    checkaccompagnement($d) {
      if ($d.checkprice === 1) {
        const k = $d.item.pid + '--prix--' + $d.dataprice[0] + '--accompagnement--' + $d.accompagnement.pid;
        const found = this.checkmycheckkey(k);
        if (Object.keys(found).length > 0) {
          this.ItemsArticle = found; this.ItemsArticle.qtite++;
          this.gestionPu($d.dataprice[0]); this.ItemsArticle.mtnt = this.montant; this.SaveArticle();
        } else {
          this.ItemsArticle.accompagnement.push($d.accompagnement);
          this.ItemsArticle.autredesignation = $d.accompagnement.name;
          this.ItemsArticle.mycheckkey = k; this.ItemsArticle.qtite = 1;
          this.ItemsArticle.article = $d.item;
          this.gestionPu($d.dataprice[0]); this.ItemsArticle.mtnt = this.montant; this.SaveArticle();
        }
      } else {
        this.$refs.modalselectprice.show($d.dataprice, $d.item, $d.accompagnement);
      }
    },
    checkprice($d) {
      let k = Object.keys($d.accompagnement).length > 0
          ? ($d.item.pid + '--prix--' + $d.price + '--accompagnement--' + $d.accompagnement.pid)
          : ($d.item.pid + '--prix--' + $d.price + '--accompagnement--');
      if (Object.keys($d.accompagnement).length > 0)
        this.ItemsArticle.autredesignation = $d.accompagnement.name;
      const found = this.checkmycheckkey(k);
      if (Object.keys(found).length > 0) {
        this.ItemsArticle = found; this.ItemsArticle.qtite++;
        this.gestionPu($d.price); this.ItemsArticle.mtnt = this.montant; this.SaveArticle();
      } else {
        this.ItemsArticle.mycheckkey = k; this.ItemsArticle.qtite = 1;
        this.ItemsArticle.article = $d.item;
        this.gestionPu($d.price); this.ItemsArticle.mtnt = this.montant; this.SaveArticle();
      }
    },
    updateentetecommande($d) { this.Items = $d.item; },

    async selectionitemforfacturation($item) {
      if (this.isSelectarticledlclik) return;
      this.isSelectarticledlclik = true;

      try {
        console.log('Article sélectionné :', $item);

        if (!this.Items.jsonotherdonne.cltfrs) {
          toastr['error']('Veuillez sélectionner un client.', '<b></b>'); return;
        }
        if (!this.Items.jsonv.client) {
          this.Items.jsonv.client = this.Items.jsonotherdonne.cltfrs.name;
          this.Items.jsonv.ifu    = this.Items.jsonotherdonne.cltfrs.ifu;
        }
        if (!this.Items.jsonotherdonne.collaborateur) {
          toastr['error']('Veuillez choisir un serveur.', '<b></b>'); return;
        }

        let $cp = 0, $dp = [];
        const pu = [[$item.prixpromo],[$item.pu],[$item.pu1],[$item.pu2],[$item.pu3],
          [$item.pu4],[$item.pu5],[$item.pu6],[$item.pu7]];
        pu.forEach(([v]) => { if (v !== 0) { $cp++; $dp.push(v); } });

        if ($cp === 1) {
          if ($item.accompagnement.length > 0) {
            this.$refs.modalaccompagnement.show($item.accompagnement, $item, $cp, $dp);
          } else {
            const k = $item.pid + '--prix--' + $dp[0] + '--accompagnement--';
            const f = this.checkmycheckkey(k);
            if (Object.keys(f).length > 0) {
              this.ItemsArticle = f;
              this.ItemsArticle.qtite++;
              this.gestionPu($dp[0]);
              this.ItemsArticle.mtnt = this.montant;
              await this.SaveArticle();
            } else {
              this.ItemsArticle.mycheckkey = k;
              this.ItemsArticle.qtite = 1;
              this.ItemsArticle.article = $item;
              this.gestionPu($dp[0]);
              this.ItemsArticle.mtnt = this.montant;
              await this.SaveArticle();
            }
          }
        }
        if ($cp > 1) {
          $item.accompagnement.length > 0
            ? this.$refs.modalaccompagnement.show($item.accompagnement, $item, $cp, $dp)
            : this.$refs.modalselectprice.show($dp, $item, {});
        }
      } finally {
        this.isSelectarticledlclik = false;
      }
    },

    gestionPu($p) {
      if (parseInt(this.Items.jsonotherdonne.appliquetva) === 1) {
        if (parseInt(this.ItemsArticle.article.tptva) === 1) {
          if (parseInt(this.ItemsArticle.article.typeprixvente) === 1) {
            this.ItemsArticle.pu = (parseFloat($p) / 1.18).toFixed(8);
            this.ItemsArticle.pa = 0;
          } else {
            this.ItemsArticle.pu = $p;
            this.ItemsArticle.pa = Math.round(parseFloat($p) * 0.18);
          }
        } else { this.ItemsArticle.pu = $p; this.ItemsArticle.pa = 0; }
      } else { this.ItemsArticle.pu = $p; this.ItemsArticle.pa = 0; }
    },

    calcullistedatatable() {
      const vm = this;
      let nt=0, aib=0, tva=0, pvht=0, pvttc=0, totht=0, totttc=0, remise=0, istva=0;
      if (this.listedatatable.length > 0) {
        this.listedatatable.forEach(line => {
          const el = parseFloat(line.etatline);
          if (el === 0 || el === 1 || el === 4) {
            istva = 0;
            const art = line.article, mht = line.mtnt, mr = line.remise;
            if (art.taxedimposition !== "A") {
              if (vm.Items.jsonotherdonne.appliquetva === "1" || vm.Items.jsonotherdonne.appliquetva === 1) {
                istva = 1;
                parseFloat(art.tptva) === 1 ? pvttc += parseFloat(mht) : pvht += parseFloat(mht);
              } else { pvttc = 0; pvht += parseFloat(mht); }
            } else { nt += parseFloat(mht); }
            remise += parseFloat(mr);
          }
        });
        totht = pvttc + pvht + nt;
        if (istva === 1) tva = pvttc * 0.18;
        const $aib = parseInt(vm.Items.jsonotherdonne.aib);
        let libaib = "AIB";
        if ($aib !== 0) { libaib = "Montant AIB (" + $aib + " %)"; aib = totht * ($aib / 100); }
        const docTypes = ["DAF","BCF","RF","FR","FRF"];
        if (docTypes.includes(this.typedoc)) {
          aib = -aib; const nf = totht + aib;
          if (istva === 1) tva = nf * 0.18;
          totttc = nf + tva;
        } else { totttc = totht + aib + tva; }
        vm.Items.mtnt = {
          doctva: Math.round(tva), docmtnttotalttc: Math.round(totttc),
          docmtntaib: Math.round(aib), docmtntremise: Math.round(remise),
          docmtnttotalht: Math.round(totht),
          doccalmtnttotalht: Math.round(totht) + Math.round(remise), libaib
        };
      } else {
        this.Items.mtnt = { doctva:0, docmtnttotalttc:0, docmtntaib:0, docmtntremise:0,
          docmtnttotalht:0, doccalmtnttotalht:0, libaib:"Montant AIB (0 %)" };
      }
    },

    newArticle() {

      this.ItemsArticle = {
        accompagnement:[], autredesignation:'', mycheckkey:'',
        /*docnum:this.Items?.docnum || '',*/
        docnum:this.Items?.pid || '',
        article:null, qtite:0, diqte:0, pu:0, pa:0, mtnt:0, mtntclt:0,
        remise:0, doc:'', docpid:this.Items?.pid || '', docnumother:'', docmag:'', doctp:'',
        linekey:'', calmtntht:0, etatline:0, pid:'', spid:''
      };
      this.disabled = false;
    },

    async SaveArticle() {
      if (this.isSaving) return;
      if (!this.Items.jsonotherdonne.cltfrs) {
        toastr['error']('Sélectionnez un client.', '<b></b>'); return;
      }
      if (!this.ItemsArticle.article) {
        toastr['error']('Article invalide.', '<b></b>'); return;
      }
      if (parseFloat(this.ItemsArticle.qtite) === 0 || parseFloat(this.ItemsArticle.mtnt) === 0 || parseFloat(this.ItemsArticle.pu) === 0) {
        toastr['error']('Quantité ou prix manquant.', '<b></b>'); return;
      }

      /* console.log('SaveArticle appelé - isNewLine:', this.ItemsArticle.linekey === "", 
              'mycheckkey:', this.ItemsArticle.mycheckkey,
              'listedatatable.length avant push:', this.listedatatable.length);*/






      const t = this;
      t.isSaving = true;
      let linekey = "", mitems, oldQty = 0;
      const isNewLine = t.ItemsArticle.linekey === "";

      if (isNewLine) {
        linekey = randomString(20);
        t.ItemsArticle.linekey = linekey; 
        t.ItemsArticle.etatline = 0;
        t.ItemsArticle.ppu = t.ItemsArticle.pu;
        t.ItemsArticle.calmtntht = parseFloat(t.ItemsArticle.remise) + parseFloat(t.ItemsArticle.mtnt);
        mitems = cloneobjet(t.ItemsArticle); 
        t.listedatatable.push(mitems);
      } 
      else {
        linekey = t.ItemsArticle.linekey;
        const existingLine = t.listedatatable.find(l => l.linekey === linekey);
        oldQty = existingLine ? parseFloat(existingLine.qtite) || 0 : 0;
        t.listedatatable.forEach(l => {
          if (l.linekey === linekey) {
            l.retatline = l.etatline; l.etatline=0; l.qtite=t.ItemsArticle.qtite; l.ppu=t.ItemsArticle.pu;
            l.pu=t.ItemsArticle.pu; l.autredesignation=t.ItemsArticle.autredesignation;
            l.mtnt=t.ItemsArticle.mtnt; l.mtntclt=t.ItemsArticle.mtntclt;
            l.remise=t.ItemsArticle.remise;
            l.calmtntht=parseFloat(t.ItemsArticle.remise)+parseFloat(t.ItemsArticle.mtnt);
          }
        });
        mitems = cloneobjet(t.ItemsArticle);
      }

      t.ItemsArticle.cf = this.$store.state.caisseinfo;
      mitems.cf = this.$store.state.caisseinfo;

      const articlePid = mitems.article.pid;
      const newQty = parseFloat(mitems.qtite) || 0;
      const stockIdx = t.stockIdxOf(articlePid);
      const stockAvailable = stockIdx >= 0 ? parseFloat(t.datatablearticle[stockIdx].rstck) : 0;
      const instock = stockIdx >= 0 ? parseFloat(t.datatablearticle[stockIdx].instock) : 0;
      const effectiveStock = stockAvailable + oldQty - newQty;

      if (instock === 1 && effectiveStock < 0) {
        const disponible = stockAvailable + oldQty;
        t.listedatatable.forEach(l => { if (l.linekey === linekey) { l.etatline=2; l.linemessage="Stock insuffisant. Dispo: " + disponible; } });
        if (isNewLine) {
          mitems.etatline = 2; mitems.linemessage = "Stock insuffisant. Dispo: " + disponible;
          t.listedatatableindexedb.push(cloneobjet(mitems));
        } else {
          t.listedatatableindexedb.forEach(l => {
            if (l.linekey === linekey) { l.etatline=2; l.linemessage="Stock insuffisant. Dispo: " + disponible; }
          });
        }
        t.calcullistedatatable();
        toastr['error']('Stock insuffisant pour "' + mitems.article.libelle + '". Dispo: ' + disponible, '<b></b>');
        t.newArticle();
        setTimeout(() => { t.isSaving = false; }, 300);
        return;
      }

      if (instock === 1) {
        t.datatablearticle[stockIdx].rstck = Math.max(0, effectiveStock);
      }

      /* ── pidindexedb ── */
      if (t.Items.pidindexedb === "") {
        t.Items.pidindexedb = await getNextTicketKey();
        t.waitNumber = numeroAffiche(t.Items.pidindexedb);
        t.Items.jsonotherdonne.tpdoc = "facture";
        t.Items.jsonotherdonne.tredocument = "vente";
        t.Items.jsonv.modereglement = t.Items.jsonotherdonne.moderglt;
        t.Items.jsonv.typ = "VENC"; t.Items.jsonv.comptabilise = 0;
      }

      /* ── listedatatableindexedb ── */

      /*console.log("Saving article line. Linekey:", linekey,"isNewLine: ", 
      isNewLine, "mitems:", mitems, "mitems.article:", mitems.article );*/




      mitems.pidindexedb = t.Items.pidindexedb;
      if (isNewLine) {
        t.listedatatableindexedb.push(cloneobjet(mitems));
      } else {
        t.listedatatableindexedb.forEach(l => {
          if (l.linekey === linekey) {
            l.etatline=0; l.qtite=mitems.qtite; l.ppu=mitems.ppu;
            l.pu=mitems.pu; l.autredesignation=mitems.autredesignation;
            l.mtnt=mitems.mtnt; l.mtntclt=mitems.mtntclt;
            l.remise=mitems.remise;
            l.calmtntht=parseFloat(mitems.remise)+parseFloat(mitems.mtnt);
          }
        });
      }

      t.newArticle();
      t.calcullistedatatable();

      /* Scroll ticket en bas */
      this.$nextTick(() => {
        const scroll = this.$refs.cartScroll;
        if (scroll) scroll.scrollTop = scroll.scrollHeight;
      });

      setTimeout(() => { t.isSaving = false; }, 300);
    },

    deleteItemArticle(ia) {
      if (!ia.article || parseFloat(ia.qtite)===0 || parseFloat(ia.mtnt)===0 || parseFloat(ia.pu)===0) {
        toastr['error']('Informations manquantes.', '<b></b>'); return;
      }
      const t = this;
      const linekey = ia.linekey;
      if (!linekey) return;

      const articlePid = ia.article.pid;
      const removedQty = parseFloat(ia.qtite) || 0;
      const stockIdx = t.stockIdxOf(articlePid);

      const idx1 = t.listedatatable.findIndex(l => l.linekey === linekey);
      if (idx1 >= 0) t.listedatatable.splice(idx1, 1);
      const idx2 = t.listedatatableindexedb.findIndex(l => l.linekey === linekey);
      if (idx2 >= 0) t.listedatatableindexedb.splice(idx2, 1);

      if (stockIdx >= 0 && parseFloat(t.datatablearticle[stockIdx].instock) === 1) {
        t.datatablearticle[stockIdx].rstck = parseFloat(t.datatablearticle[stockIdx].rstck) + removedQty;
        t.$store.commit('listedesarticlespourlacaisse', { value: t.datatablearticle });
      }
      this.newArticle(); this.calcullistedatatable();
    },


    async saveItems() {

  if (parseFloat(this.Items.mtnt.docmtnttotalttc) === 0) {
    toastr['error']('Ajoutez au moins un article.', '<b></b>'); return;
  }
  if (this.Items.jsonotherdonne.moderglt === null) {
    toastr['error']('Veuillez séléctionner le mode de réglement', '<b></b>'); return;
  }

  this.$store.dispatch('lancerchargement', true);
  this.Items.cf = this.$store.state.caisseinfo;

  if (this.$store.state.authorizeprix0 === "false" || this.$store.state.authorizeprix0 === false) {
    if (!this.Items.jsonotherdonne.montantrecu) {
      toastr['error']('Saisissez le montant reçu.', '<b></b>');
      this.$store.dispatch('lancerchargement', false); return;
    }
  }
  if (this.$store.state.authorizefacturactionpartiel === "false" || this.$store.state.authorizefacturactionpartiel === false) {
    if (this.Items.mtnt.docmtnttotalttc > this.Items.jsonotherdonne.montantrecu) {
      toastr['error']('Montant reçu insuffisant.', '<b></b>');
      this.$store.dispatch('lancerchargement', false); return;
    }
  }

  const value = {
    cf: this.$store.state.caisseinfo, dpid: this.Items.pid,
    dmtnt: this.Items.jsonotherdonne.montantrecu,
    jsonotherdonne: this.Items.jsonotherdonne,
    jsonv: this.Items.jsonv,
    moderglt: this.Items.jsonotherdonne.moderglt,
    document: "FCOMPTOIRE", item: this.Items,
    isNormalisationEtat: this.isNormalisationEtat, componnent: 3,
  };

  const url = process.env.VUE_APP_API_URL + '/egl74587kjkjrfdkcaisse771714dfe/doc/caisse/addfkdfkdozojdj_refdepdpcc/' + this.$store.state.appsociete + '/add895418init51_refdepdpcc11515/' + randomString();

  try {
    const res = await axios.post(url, value, { headers: this._headers(), withCredentials: true });
    this.$store.dispatch('lancerchargement', false);

    if (res.data.success) {
      toastr['success'](res.data.message, '<b></b>');
      let normalise = 0, sig = "", nim = "", cpt = "", heure = "", qrr = "", qrImg = "";

      if (this.$store.state.authorizenormalisation === "true" || this.$store.state.authorizenormalisation === true) {
        const mf = res.data.m.mecef;
        sig = mf.mecefsignature; nim = mf.mecefnim; cpt = mf.mecefcompteur;
        heure = mf.mecefheure; qrr = mf.mecefqrr; normalise = mf.normalise;
        qrcodetoimage.toDataURL(qrr, { width: 125, margin: 2 }, (err, u) => { if (!err) qrImg = u; });
      }

      const items = this.listedatatable.filter(l => l.etatline !== 2);
      const tabvalue = {
        numdoc: this.Items.docnum, date: this.Items.datedoc,
        client: this.Items.jsonv.client, ifu: this.Items.jsonv.ifu,
        params: '', params4: '', boutique: '',
        serveur: this.Items.jsonv.collaborateur ? this.Items.jsonv.collaborateur.name : '',
        commandetable: this.Items.jsonv.commandetable ? this.Items.jsonv.commandetable.name : '',
        vendeur: this.$store.state.appusername, items,
        montantht: this.calculSomme(this.Items.mtnt.docmtnttotalht, this.Items.mtnt.docmtntremise, 0),
        montanttva: 0,
        montantremise: this.currencyFormatDE(this.Items.mtnt.docmtntremise),
        montantnetapayer: this.currencyFormatDE(this.Items.mtnt.docmtnttotalttc),
        reglement: this.currencyFormatDE(this.Items.jsonotherdonne.montantrecu),
        montantmonnaie: this.calculMonnaie(this.Items.mtnt.docmtnttotalttc, this.Items.jsonotherdonne.montantrecu),
        pourcentageprisenecharge: 0, docsaisiepar: this.$store.state.appusername,
        normalise, mecefsignature: sig, mecefnim: nim, mecefcompteur: cpt,
        mecefheure: heure, mecefqrr: qrImg,
      };
      if (this.Items.jsonv.param !== null) tabvalue.params = this.Items.jsonv.param.name;

//console.log('Marking queue completed for pidindexedb:', this.Items.pidindexedb, 'docnum:', this.Items.docnum, 'pid:', this.Items.pid);

      await markQueueCompleted(this.Items.pidindexedb, this.Items.docnum, this.Items.pid);

      this.$refs.modalfacturecomptoirepost.show(tabvalue, 'facture');
    } else {
      const msg = res.data.datamessage && res.data.datamessage.length
        ? res.data.datamessage.join(' , ') : res.data.message;
      toastr['error'](msg, '<b></b>');
    }
  } catch {
    toastr['error']('Erreur serveur.', '<b></b>');
  } finally {
    this.$store.dispatch('lancerchargement', false);
  }
},

 
    /* ── formatage ── */
    currencyFormatDE(p) { return currencyFormatDE(Number(p)); },
    formatNumber2(p)    { return FormatNumber(Number(p)); },
    formatNumber(n)     { return currencyFormatDE(n); },

    /* ── mise en attente / nouvelle facture ── */
    async envoyerCommande(srvdocnum="",srvpid="", skipNewInvoice=false) {

      if (this.compteprocess > 0) return; 

         const t = this;
      t.compteprocess++;
      this.$store.dispatch('lancerchargement', true);

      if (!this.Items.pidindexedb || !this.listedatatableindexedb.length) {
        this.$store.dispatch('lancerchargement', false);
        t.compteprocess--;
        toastr['error']('Aucune commande à envoyer.', '<b></b>'); return;
      
      }
      const errored = this.listedatatableindexedb.filter(l => l.etatline === 2);
      if (errored.length) {
         this.$store.dispatch('lancerchargement', false);
         t.compteprocess--;
        toastr['error']('Corrigez les lignes en erreur avant d\'envoyer.', '<b></b>');
         return;
      }

       for (const $line of this.listedatatableindexedb) {
              $line.etatline = 1; 
            }

       for (const $line of this.listedatatable) {
              $line.etatline = 1; 
            }
   
      t.Items.cf = this.$store.state.caisseinfo;
      t.Items.jsonv.modereglement = t.Items.jsonotherdonne.moderglt;
      t.Items.jsonotherdonne.tpdoc = "facture"; 
      t.Items.jsonotherdonne.tredocument = "vente";
      t.Items.jsonv.typ = "VENC"; 
      t.Items.jsonv.comptabilise = 0;

      const isUpdate = !!(t.Items.pidindexedb && t.Items.docpid && t.Items.docnum);

      const $createdAt= Date.now()
      const payload = {
        createdat:$createdAt,
        pidindexedb: t.Items.pidindexedb,
        itemdoc: cloneobjet(t.Items),
        docnum: t.Items.docnum ? t.Items.docnum : '',
        docpid: t.Items.docpid ? t.Items.docpid : '',
        //lines: cloneobjet(t.listedatatableindexedb),
        lines: cloneobjet(t.listedatatable),
        cf: this.$store.state.caisseinfo,
      };

      const queuePayload = {
        pidindexedb: t.Items.pidindexedb,
        datedoc: t.Items.datedoc,
        Items: cloneobjet(t.Items),
        listedatatableindexedb: cloneobjet(t.listedatatableindexedb),
        listedatatable: cloneobjet(t.listedatatable),
        jsonv: cloneobjet(t.Items.jsonv),
        jsonotherdonne: cloneobjet(t.Items.jsonotherdonne),
        mtnt: cloneobjet(t.Items.mtnt),
        client: t.Items.jsonv.client,
        serveur: t.Items.jsonv.collaborateur ? t.Items.jsonv.collaborateur.name : '',
        commandetable: t.Items.jsonv.commandetable ? t.Items.jsonv.commandetable.name : '',
        createdAt: $createdAt,
        srvdocnum: t.Items.docnum ? t.Items.docnum : '',
        srvpid: t.Items.docpid ? t.Items.docpid : '',
        _syncedFromServer:      false,
        source:'local'
      };


 /*

      console.log('Queue t.Items.pidindexedb prepared:', t.Items.pidindexedb);
      console.log('Queue t.Items.docpid prepared:', t.Items.docpid);
      console.log('Queue t.Items.docnum prepared:', t.Items.docnum);
      console.log('Queue isUpdate prepared:', isUpdate);
      console.log('Queue queuePayload prepared:', queuePayload);
      console.log('Queue payload prepared:', payload);


      return;*/

      try {
        if (isUpdate) {
          await updateQueueData(t.Items.pidindexedb, queuePayload);
        } else {
          await addToQueue(t.Items.pidindexedb, queuePayload);
        }
      } catch(e) {console.error('Queue error:', e);}

      const url = process.env.VUE_APP_API_URL + '/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/' + this.$store.state.caisseencour + '/' + this.$store.state.appsociete + '/batch895418init51comptoirerefdepdpcc11515/option2/' + randomString(280);
      try {
        const res = await axios.post(url, payload, { headers: this._headers(), withCredentials: true });
        t.$store.dispatch('lancerchargement', false);
        if (res.data.success) {
          t.Items.docnum = res.data.numdoc || t.Items.docnum;
          t.Items.docpid = res.data.keypid || t.Items.docpid;
          t.Items.pid = res.data.keypid || t.Items.pid;
          const keyLines = res.data.keylines || [];
          t.listedatatable.forEach(l => {
            const match = keyLines.find(k => k.linekey === l.linekey);
            if (match) { l.etatline = 1; l.pid = match.keyline; l.docnum = match.keypid; l.docpid = match.keypid; }
          });

          if (res.data.stockUpdates) {
            for (const su of res.data.stockUpdates) {
              const idx = t.stockIdxOf(su.pid);
              if (idx >= 0 && parseFloat(t.datatablearticle[idx].instock) === 1) {
                t.datatablearticle[idx].rstck = su.rstck;
              }
            }
            t.$store.commit('listedesarticlespourlacaisse', { value: t.datatablearticle });
          }
          t.listedatatableindexedb = [];
          //await markQueueCompleted(t.Items.pidindexedb, res.data.numdoc || t.Items.docnum, res.data.keypid || t.Items.docpid);
          await markQueuePending(t.Items.pidindexedb, res.data.numdoc, res.data.keypid);
           if (!skipNewInvoice) toastr['success']('Commande ' + numeroAffiche(t.Items.pidindexedb) + ' envoyée.', '<b></b>');
          t.compteprocess--;
        await this.refreshQueueCount();
          if (!skipNewInvoice) t.newinvoice();
        }
        else {
          toastr['error'](res.data.message || 'Erreur serveur', '<b></b>');
          //t.listedatatableindexedb.forEach(l => { l.etatline = 2; l.linemessage = 'Erreur envoi: ' + (res.data.message || ''); });
          await markQueueFailed(t.Items.pidindexedb, res.data.message || 'Erreur serveur');
          t.compteprocess--;
          await this.refreshQueueCount();
        }
      } catch(e) {
        t.$store.dispatch('lancerchargement', false);
        toastr['error']('Erreur réseau.', '<b></b>');
        await markQueueFailed(t.Items.pidindexedb, 'Erreur réseau');
        t.compteprocess--;
        await this.refreshQueueCount();
      }
    },

     async refreshQueueCount() {
      try {
        const count = await getQueueCount();
        this.nbrefactureenattante = count;
      } catch (e) {}
    },

 

    Misecommandeenattente() { this.envoyerCommande(); },
    newinvoice() {
      this.listedatatable = [];
      this.listedatatableindexedb = [];
      this.isSaving = false;
      this.ItemsArticle = {
        accompagnement:[], autredesignation:'', mycheckkey:'', docnum:'',
        article:null, qtite:0, diqte:0, pu:0, pa:0, mtnt:0, mtntclt:0,
        remise:0, doc:'', docpid:'', docnumother:'', docmag:'', doctp:'',
        linekey:'', calmtntht:0, etatline:0, pid:''
      };
      this.Items = this._blankItems();
    },

    _blankItems() {
      return {
        pid:'', pidindexedb:'', mag:null, datedoc:this.$store.state.dateouverturecaisse,
        docobservation:'', docnum:'', docnumother:'', docpid:0, doctyp:'',
        infodoc:{infolibre:'', infolibre1:'', infolibre2:'', infolibre3:''},
        jsonotherdonne:{
          montantrecu:0, tpdoc:"", tredocument:"", mtypprixdevente:"prixvente",
          magvers:null, collaborateur:null, commandetable:null,
          cltfrs:null, moderglt:null, cdtreglement:null, appliquetva:0, aib:0,
          adresseexpedition:{infolibre:'', infolibre1:'', infolibre2:'', infolibre3:''},
          infodoc:{infolibre:'', infolibre1:'', infolibre2:'', infolibre3:''},
        },
        mtnt:{montanthtassurance:0, docmtntaib:0, docmtntremise:0,
          docmtnttotalht:0, docmtnttotalttc:0, doctva:0, doccalmtnttotalht:0, libaib:"AIB"},
        params:{param1:null, param2:null, param3:null, param4:null},
        jsondoc:{},
        jsonv:{ifu:'', client:'', telephone:'', collaborateur:null, modereglement:null,
          commandetable:null, indicateur:'', indicateur1:'', param:null, param1:null,
        isnormalisationetat:false}
      };
    },

    _headers() {
      return {
        'X-Requested-With':'XMLHttpRequest', 'Accept':'application/json',
        'Content-Type':'application/json',
        'Authorization':'Bearer ' + JwtService.getToken(),
        'csrftoken': this.$store.state.appsociete
      };
    },

    /* ── chargement ── */
    async load() {
      const t = this;
      const url = process.env.VUE_APP_API_URL + '/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/' + this.$store.state.caisseencour + '/' + this.$store.state.appsociete + '/load895418init51comptoirerefdepdpcc11515/option2/' + randomString(280);
      await axios.post(url, {cf:this.$store.state.caisseinfo, document:"FV"}, {headers:this._headers(), withCredentials:true})
          .then(res => { t.datatable = res.data.success ? res.data.m : []; })
          .catch(() => {});
    },
    async loadreturnotherdata() {
      const t = this;
      const url = process.env.VUE_APP_API_URL + '/egl745874pdefinition771714dfe/caisse/othetdskd8755dsdhisd/other111dksdk/option2/' + this.$store.state.appsociete + '/' + randomString();
      await axios.get(url, {headers:this._headers(), withCredentials:true})
          .then(res => { t.otherdatatable = res.data.success ? res.data.otherdata : {}; })
          .catch(() => {this.$store.dispatch('lancerchargement', false);})
          .finally(() => this.$store.dispatch('lancerchargement', false));
    },
    async loadinputlibelleforms() {
      const $v = JwtService.getVALUEDATAPRICE();
      if (isset($v)) { this.datainputlibelleforms = JSON.parse($v); return; }
      const t = this;
      const url = process.env.VUE_APP_API_URL + '/12478855libelinputindex2iofdofiloadexp2/' + this.$store.state.appsociete + '/' + randomString();
      await axios.get(url, {headers:this._headers(), withCredentials:true})
          .then(res => {
            if (res.data.success) {
              t.datainputlibelleforms = res.data.valuedataprice;
              JwtService.setVALUEDATAPRICE(JSON.stringify(t.datainputlibelleforms));
            }
          })
          .catch(() => {this.$store.dispatch('lancerchargement', false);})
          .finally(() => this.$store.dispatch('lancerchargement', false));
    },

    close() { this.teardownInfiniteScroll(); this.isdisplay = false; this.$emit('closed', this.datatablearticle); },

    handleKeydown(e) {
      if (!this.isdisplay) return;
      const tag = document.activeElement && document.activeElement.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      switch(e.key) {
        case 'F5':  e.preventDefault(); this.note(); break;
        case 'F6':  e.preventDefault(); this.printBon('cuisine'); break;
        case 'F7':  e.preventDefault(); this.printBon('bar'); break;
        case 'F8':  e.preventDefault(); this.printBon('caisse'); break;
        case 'F9':  e.preventDefault(); this.envoyerCommande(); break;
        case 'F10': e.preventDefault(); this.newinvoice(); break;
      }
    },

 
   async show() {
      if (!this.$store.state.caisseencour) {
        toastr['error']("Sélectionnez une caisse valide.");
        this.$router.push({name:'tcaisse'}); return;
      }
       _autoCleanCompleted();
      this.messagesucces = ""; this.messageerror = "";
      this.titlemodal = "";
      this.Items = this._blankItems(); 
      this.newinvoice();
      this.loadinputlibelleforms();
      /* La liste des clients arrive en asynchrone : la pré-sélection ne peut se
         faire qu'une fois loadreturnotherdata() résolue. */
      this.loadreturnotherdata().then(() => this.appliquerClientParDefaut());
      await getQueueCount().then(count => {
          if (count > 0) {
            toastr['info'](`Il y a ${count} commande(s) en attente d'envoi.`, '<b></b>');

            this.nbrefactureenattante = count;
          }
        });
      //this.load();
      this.fabOpen = false;
      this.showMobileOrder = false;
      this.isdisplay = true;
      cleanExpiredOrders().catch(() => {this.$store.dispatch('lancerchargement', false);});
      this.$nextTick(() => {
        this.visibleCount = this.articleChunk;
        this.setupInfiniteScroll();
        this.fillViewport();
      });
    },
  },

  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },

  beforeUnmount() {
    this.teardownInfiniteScroll();
    document.removeEventListener('keydown', this.handleKeydown);
  },

  setup(props) {
    // Injecter la méthode 'addCompte' provenant du parent
    const btnreinitialiserAllarticle = inject('reinitialiserAllarticle');
    const loadsoldecaisse = inject('loadsoldecaisse');


    const handlebtnreinitialiserAllarticle = () => {

      // Appel de la méthode injectée
      if (btnreinitialiserAllarticle) {
        btnreinitialiserAllarticle();
      }

    };

    const handleloadsoldecaisse = () => {

      // Appel de la méthode injectée
      if (loadsoldecaisse) {
        loadsoldecaisse();
      }

    };



    return {
      handlebtnreinitialiserAllarticle,
      handleloadsoldecaisse

    };
  },







}
</script>

<style scoped>
/* ══════════════════════════════════════════
   VARIABLES - dark (défaut) / light (toggle)
══════════════════════════════════════════ */
.theme-dark {
  --bg:       #0f172a; /* slate-900 */
  --surface:  #1e293b; /* slate-800 */
  --surface2: #334155; /* slate-700 */
  --border:   #475569; /* slate-600 */
  --text:     #f1f5f9; /* slate-100 */
  --text2:    #94a3b8; /* slate-400 */
  --text3:    #475569; /* slate-600 */
  --accent:   #22c55e; /* orange-500 #f97316 */
  --accent-h: #22c55e; /* orange-600 #ea580c */
  --green:    #22c55e; /* green-500  */
  --red:      #ef4444; /* red-500    */
  --blue:     #3b82f6; /* blue-500   */
  --amber:    #f59e0b; /* amber-500  */
  --purple:   #a855f7; /* purple-500 */
}
.theme-light {
  --bg:       #f8fafc; /* slate-50  */
  --surface:  #ffffff;
  --surface2: #f1f5f9; /* slate-100 */
  --border:   #e2e8f0; /* slate-200 */
  --text:     #0f172a; /* slate-900 */
  --text2:    #64748b; /* slate-500 */
  --text3:    #cbd5e1; /* slate-300 */
  --accent:   #22c55e; /* #2563eb  */
  --accent-h: #22c55e;
  --green:    #16a34a; /* green-600  */
  --red:      #dc2626; /* red-600    */
  --blue:     #2563eb; /* blue-600   */
  --amber:    #d97706; /* amber-600  */
  --purple:   #9333ea; /* purple-600 */
}

/* ── overlay plein écran ── */
.pos3-overlay {
  position: fixed; inset: 0; z-index: 9999;
  background: var(--bg); color: var(--text);
  font-family: 'Segoe UI', system-ui, sans-serif;
  display: flex; flex-direction: column;
}
.pos3-shell { display: flex; flex-direction: column; height: 100dvh; overflow: hidden; }

/* ══ TOPBAR ══ */
.pos3-topbar {
  display: flex; align-items: center; gap: 8px;
  padding: 8px 14px; flex-shrink: 0;
  background: var(--surface); border-bottom: 1px solid var(--border);
}
.pos3-appname { font-size: 15px; font-weight: 800; color: var(--accent); white-space: nowrap; }
.pos3-topbar-center { display: flex; align-items: center; gap: 6px; flex: 1; overflow: hidden; }
.pos3-chip {
  font-size: 11px; font-weight: 700; padding: 3px 8px; border-radius: 6px;
  background: var(--surface2); border: 1px solid var(--border); color: var(--text2); white-space: nowrap;
}
.chip-accent { color: var(--accent); border-color: var(--accent); }
.chip-warn   { color: var(--amber);  border-color: var(--amber); }
.chip-wait   { color: var(--purple); border-color: var(--purple); }
.pos3-spin   { display: inline-block; animation: spin .8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }

.pos3-topbar-right { display: flex; gap: 6px; flex-shrink: 0; }
.pos3-topbtn {
  position: relative; width: 34px; height: 34px; border-radius: 8px;
  border: 1px solid var(--border); background: var(--surface2);
  color: var(--text2); cursor: pointer; font-size: 16px;
  display: flex; align-items: center; justify-content: center; transition: all .12s;
}
.pos3-topbtn:hover { border-color: var(--accent); color: var(--text); }
.pos3-topbtn-danger:hover { border-color: var(--red); color: var(--red); }

/* ══ MAIN GRID ══ */
.pos3-main { display: grid; grid-template-columns: 1fr 320px; flex: 1; min-height: 0; overflow: hidden; }

/* ══ LEFT ══ */
.pos3-left { display: flex; flex-direction: column; overflow: hidden; }
.pos3-toolbar {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  padding: 8px 12px; flex-shrink: 0;
  background: var(--surface); border-bottom: 1px solid var(--border);
}
.pos3-search-wrap { position: relative; flex: 1; min-width: 160px; }
.pos3-search-icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: var(--text3); pointer-events: none; }
.pos3-search {
  width: 100%; padding: 8px 32px 8px 32px;
  background: var(--surface2); border: 1px solid var(--border);
  border-radius: 8px; color: var(--text); font-size: 13px; outline: none; font-family: inherit;
}
.pos3-search::placeholder { color: var(--text3); }
.pos3-search-clear {
  position: absolute; right: 8px; top: 50%; transform: translateY(-50%);
  background: none; border: none; color: var(--text2); cursor: pointer; font-size: 14px; padding: 0;
}
.pos3-cats { display: flex; gap: 5px; overflow-x: auto; flex: 2; min-width: 0; scrollbar-width: none; }
.pos3-cats::-webkit-scrollbar { display: none; }
.pos3-cat {
  padding: 5px 12px; border-radius: 20px; font-size: 11px; font-weight: 700;
  white-space: nowrap; flex-shrink: 0; cursor: pointer; font-family: inherit;
  background: var(--surface2); color: var(--text2); border: 1px solid var(--border); transition: all .12s;
}
.pos3-cat.active, .pos3-cat:hover { background: var(--accent); color: #fff; border-color: var(--accent); }

.pos3-items-grid {
  flex: 1; overflow-y: auto; padding: 10px 12px;
  display: grid; grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 8px; align-content: start;
  scrollbar-width: thin; scrollbar-color: var(--border) transparent;
}
.pos3-item-card {
  background: var(--surface); border: 1px solid var(--border); border-radius: 10px;
  padding: 11px 10px; cursor: pointer; position: relative; user-select: none;
  display: flex; flex-direction: column; gap: 4px; transition: border-color .1s, transform .08s;
}
.pos3-item-card:active { transform: scale(.95); }
.pos3-item-card:hover  { border-color: var(--accent); }
.pos3-item-card.in-order { border-color: var(--accent); background: var(--surface2); }
.pos3-item-card.low-stock {
  border-color: var(--red) !important;
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--red) 30%, transparent);
}
.pos3-ic-em   { font-size: 20px; color: var(--text2); }
.pos3-ic-name { font-size: 12px; font-weight: 700; color: var(--text); line-height: 1.3; }
.pos3-ic-footer { display: flex; align-items: center; justify-content: space-between; gap: 4px; margin-top: 2px; flex-wrap: wrap; }
.pos3-ic-price  { font-size: 13px; font-weight: 800; color: var(--accent); }
.pos3-ic-badge  {
  position: absolute; top: 5px; right: 5px; background: var(--red); color: #fff;
  border-radius: 50%; width: 18px; height: 18px; font-size: 10px; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
}
.pos3-ic-tag  { font-size: 9px; font-weight: 700; padding: 1px 5px; border-radius: 4px; background: var(--surface2); color: var(--text3); }
.pos3-ic-tag.tag-stock { color: var(--text2); border: 1px solid var(--border); display: inline-flex; align-items: center; gap: 2px; }
.tag-warn     { color: var(--amber) !important; border-color: var(--amber) !important; }
.pos3-empty-grid { grid-column: 1/-1; text-align: center; color: var(--text3); padding: 40px 20px; font-size: 13px; }

/* Scroll infini : sentinelle observée + indicateur de chargement */
.pos3-scroll-sentinel { grid-column: 1/-1; min-height: 1px; }
.pos3-scroll-loader { display: flex; align-items: center; justify-content: center; gap: 8px;
  padding: 16px 0; color: var(--text3); font-size: 13px; }

/* ══ RIGHT ══ */
.pos3-right { background: var(--surface); border-left: 1px solid var(--border); display: flex; flex-direction: column; overflow: hidden; }
.pos3-right-top { padding: 10px 12px; border-bottom: 1px solid var(--border); display: flex; flex-direction: column; gap: 7px; flex-shrink: 0; }
.pos3-rt-row  { display: flex; align-items: center; gap: 6px; }
.pos3-rt-lbl  { font-size: 11px; font-weight: 700; color: var(--text3); white-space: nowrap; min-width: 44px; }
.pos3-rt-sel  {
  flex: 1; min-width: 0; padding: 6px 10px; border-radius: 7px;
  background: var(--surface2); border: 1px solid var(--border);
  color: var(--text); font-size: 12px; font-weight: 600; outline: none; cursor: pointer; font-family: inherit;
}
.pos3-details-btn {
  padding: 5px 9px; border-radius: 6px; font-size: 11px; font-weight: 700; cursor: pointer;
  background: var(--surface2); border: 1px solid var(--border); color: var(--text2);
  white-space: nowrap; font-family: inherit; transition: all .12s; flex-shrink: 0;
}
.pos3-details-btn:hover { border-color: var(--accent); color: var(--accent); }

/* order list */
.pos3-order-list { flex: 1; overflow-y: auto; padding: 6px 8px; scrollbar-width: thin; scrollbar-color: var(--border) transparent; }
.pos3-empty-order { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; color: var(--text3); gap: 8px; text-align: center; padding: 20px; }
.pos3-empty-ico { font-size: 32px; }
.pos3-empty-order p  { font-size: 12px; line-height: 1.7; }
.pos3-empty-order small { font-size: 11px; }

.pos3-oi { display: flex; align-items: flex-start; gap: 6px; padding: 8px 4px; border-bottom: 1px solid var(--border); }
.pos3-oi:last-child { border-bottom: none; }
.oi-wait { opacity: .7; }
.oi-err  { background: color-mix(in srgb, var(--red) 8%, transparent); border-radius: 6px; }

.pos3-st-ok   { font-size: 9px; font-weight: 800; padding: 2px 5px; border-radius: 4px; background: color-mix(in srgb, var(--green)  15%, transparent); color: var(--green); flex-shrink:0; }
.pos3-st-err  { font-size: 9px; font-weight: 800; padding: 2px 5px; border-radius: 4px; background: color-mix(in srgb, var(--red)    15%, transparent); color: var(--red);   flex-shrink:0; }
.pos3-st-wait { font-size: 9px; font-weight: 800; padding: 2px 5px; border-radius: 4px; background: color-mix(in srgb, var(--amber)  15%, transparent); color: var(--amber); flex-shrink:0; }

.pos3-oi-info { flex: 1; min-width: 0; }
.pos3-oi-name { font-size: 12px; font-weight: 700; color: var(--text); }
.pos3-oi-name em { font-style: normal; color: var(--text2); font-size: 11px; }
.pos3-oi-sub  { font-size: 11px; color: var(--text2); margin-top: 1px; }
.pos3-oi-err  { font-size: 10px; color: var(--red); margin-top: 3px; }

.pos3-oi-right { display: flex; flex-direction: column; align-items: flex-end; gap: 4px; flex-shrink: 0; }
.pos3-oi-total { font-size: 12px; font-weight: 800; color: var(--accent); }
.pos3-oi-btns  { display: flex; gap: 4px; }
.pos3-mini-btn { width: 24px; height: 24px; border-radius: 5px; border: none; cursor: pointer; font-size: 12px; display: flex; align-items: center; justify-content: center; transition: opacity .1s; }
.btn-edit { background: color-mix(in srgb, var(--blue)  18%, transparent); color: var(--blue); }
.btn-del  { background: color-mix(in srgb, var(--red)   18%, transparent); color: var(--red);  }
.pos3-mini-btn:hover { opacity: .75; }

/* footer */
.pos3-order-footer { border-top: 1px solid var(--border); padding: 10px 12px; flex-shrink: 0; }
.pos3-totals { margin-bottom: 8px; }
.pos3-trow { display: flex; justify-content: space-between; font-size: 12px; color: var(--text2); padding: 2px 0; }
.pos3-trow-main { font-size: 16px; font-weight: 800; color: var(--text); padding: 4px 0; }
.text-red   { color: var(--red)   !important; }
.text-green { color: var(--green) !important; }

.pos3-note-btn {
  width: 100%; padding: 9px; border-radius: 8px; margin-bottom: 6px;
  border: 1px solid var(--border); background: var(--surface2); color: var(--text2);
  font-size: 12px; font-weight: 700; cursor: pointer; font-family: inherit; transition: all .12s;
  display: flex; align-items: center; justify-content: center; gap: 6px;
}
.pos3-note-btn kbd {
  font-size: 9px; font-weight: 700; padding: 1px 5px; border-radius: 3px;
  background: var(--surface); border: 1px solid var(--border); color: var(--text3);
  font-family: inherit; margin-left: auto;
}
.pos3-note-btn:hover:not(:disabled) { border-color: var(--amber); color: var(--amber); }
.pos3-note-btn:disabled { opacity: .4; cursor: not-allowed; }

.pos3-print-group { margin-bottom: 8px; }
.pos3-print-subrow { display: flex; gap: 5px; }
.pos3-print-subrow .pos3-note-btn { margin-bottom: 3px; flex: 1; font-size: 11px; }
.pos3-print-subrow .pos3-note-btn:last-child { margin-bottom: 3px; }
.pos3-note-cuisine:hover:not(:disabled) { border-color: var(--green); color: var(--green); }
.pos3-note-bar:hover:not(:disabled)     { border-color: var(--blue);  color: var(--blue);  }
.pos3-note-caisse:hover:not(:disabled)  { border-color: var(--amber); color: var(--amber); }

.pos3-pause-btn {
  width: 100%; padding: 10px; border-radius: 8px; margin-bottom: 6px;
  border: 1px solid var(--purple); background: color-mix(in srgb, var(--purple) 12%, transparent);
  color: var(--purple); font-size: 13px; font-weight: 700;
  cursor: pointer; font-family: inherit; transition: all .12s;
  display: flex; align-items: center; justify-content: center; gap: 6px;
}
.pos3-pause-btn kbd {
  font-size: 9px; font-weight: 700; padding: 1px 5px; border-radius: 3px;
  background: var(--surface); border: 1px solid var(--border); color: var(--text3);
  font-family: inherit; margin-left: auto;
}
.pos3-pause-wait {
  font-size: 10px; font-weight: 800; padding: 1px 6px; border-radius: 4px;
  background: var(--purple); color: #fff;
}
.pos3-pause-btn:hover:not(:disabled) { background: color-mix(in srgb, var(--purple) 22%, transparent); border-color: var(--purple); }
.pos3-pause-btn:disabled { opacity: .4; cursor: not-allowed; }

.pos3-cpt-btn {
  width: 100%; padding: 12px; border-radius: 8px; border: none;
  background: var(--accent); color: #fff; font-size: 14px; font-weight: 800;
  cursor: pointer; font-family: inherit; transition: background .12s;
}
.pos3-cpt-btn:hover:not(.disabled) { background: var(--accent-h); }
.pos3-cpt-btn.disabled { background: var(--surface2); color: var(--text3); cursor: not-allowed; }

/* ══ MOBILE BAR ══ */
.pos3-mobile-bar { display: none; }

/* ══ FAB ══ */
.pos3-fab-group { position: fixed; bottom: 24px; right: 20px; z-index: 10010; display: flex; flex-direction: column-reverse; align-items: flex-end; gap: 0; }

.pos3-fab-trigger {
  width: 46px; height: 46px; border-radius: 50%;
  background: var(--accent); border: none; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 16px color-mix(in srgb, var(--accent) 45%, transparent);
  color: #fff; transition: transform .18s, background .18s; z-index: 2;
  animation: pulse-fab 2.5s infinite;
}
.pos3-fab-trigger svg { width: 20px; height: 20px; }
.pos3-fab-trigger:hover { transform: scale(1.08); background: var(--accent-h); }
.pos3-fab-trigger.open  { transform: rotate(45deg); animation: none; }
@keyframes pulse-fab {
  0%,100% { box-shadow: 0 4px 16px color-mix(in srgb, var(--accent) 45%, transparent); }
  50%      { box-shadow: 0 4px 24px color-mix(in srgb, var(--accent) 70%, transparent); }
}

.pos3-fab-children { display: flex; flex-direction: column-reverse; align-items: flex-end; gap: 10px; margin-bottom: 10px; }

.pos3-fab-item {
  position: relative; width: 40px; height: 40px; border-radius: 50%;
  border: none; cursor: pointer; font-size: 17px;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 2px 10px rgba(0,0,0,.3); transition: transform .15s;
  color: #fff;
}
.pos3-fab-item:hover  { transform: scale(1.12); }
.pos3-fab-item:active { transform: scale(.92); }
.pos3-fab-item:disabled { opacity: .4; cursor: not-allowed; }

.fab-blue   { background: var(--blue);   }
.fab-amber  { background: var(--amber);  }
.fab-purple { background: var(--purple); }
.fab-slate  { background: var(--surface2); color: var(--text2); border: 1px solid var(--border); }
.fab-green  { background: var(--green);  }
.fab-red    { background: var(--red, #e53e3e); }

.pos3-fab-badge {
  position: absolute; top: -3px; right: -3px;
  background: var(--red); color: #fff; border-radius: 50%;
  width: 16px; height: 16px; font-size: 9px; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
}
.pos3-fab-tip {
  position: absolute; right: 50px; top: 50%; transform: translateY(-50%);
  background: var(--surface); border: 1px solid var(--border); color: var(--text);
  font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 6px;
  white-space: nowrap; pointer-events: none; opacity: 0; transition: opacity .15s;
}
.pos3-fab-item:hover .pos3-fab-tip { opacity: 1; }

/* FAB transition */
.fab-pop-enter-active { transition: all .18s ease; }
.fab-pop-leave-active { transition: all .12s ease; }
.fab-pop-enter-from, .fab-pop-leave-to { opacity: 0; transform: scale(.5) translateY(8px); }

/* ══ MODALS ══ */
.pos3-modal-overlay {
  position: fixed; inset: 0; z-index: 10020;
  background: rgba(0,0,0,.6); display: flex; align-items: center; justify-content: center;
  padding: 16px;
}
.pos3-modal {
  background: var(--surface); border: 1px solid var(--border); border-radius: 12px;
  width: min(360px, 100%); max-height: 90dvh; display: flex; flex-direction: column; overflow: hidden;
}
.pos3-modal-lg { width: min(440px, 100%); }

.pos3-modal-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 18px; border-bottom: 1px solid var(--border); flex-shrink: 0;
  font-size: 14px; font-weight: 800; color: var(--text); gap: 8px;
}
.pos3-modal-head button { background: none; border: none; color: var(--text2); font-size: 20px; cursor: pointer; line-height: 1; }

.pos3-modal-body {
  padding: 16px 18px; overflow-y: auto; flex: 1;
  display: flex; flex-direction: column; gap: 12px;
  scrollbar-width: thin; scrollbar-color: var(--border) transparent;
}
.pos3-modal-foot {
  display: flex; gap: 8px; justify-content: flex-end;
  padding: 12px 18px; border-top: 1px solid var(--border); flex-shrink: 0;
}

.pos3-lbl   { font-size: 11px; font-weight: 700; color: var(--text3); }
.pos3-input {
  width: 100%; padding: 8px 12px; border-radius: 8px;
  background: var(--surface2); border: 1px solid var(--border);
  color: var(--text); font-size: 13px; outline: none; font-family: inherit;
}
.pos3-input:focus { border-color: var(--accent); }
.pos3-input::placeholder { color: var(--text3); }
.pos3-input-lg { font-size: 16px; font-weight: 700; text-align: right; }

.pos3-btn-pri {
  padding: 9px 18px; border-radius: 8px; border: none;
  background: var(--accent); color: #fff; font-size: 13px; font-weight: 700;
  cursor: pointer; font-family: inherit; transition: background .12s;
}
.pos3-btn-pri:hover:not(.disabled) { background: var(--accent-h); }
.pos3-btn-pri.disabled, .pos3-btn-pri:disabled { background: var(--surface2); color: var(--text3); cursor: not-allowed; }
.pos3-btn-sec {
  padding: 9px 14px; border-radius: 8px;
  background: var(--surface2); border: 1px solid var(--border);
  color: var(--text2); font-size: 13px; cursor: pointer; font-family: inherit;
}

/* modes de règlement */
.pos3-pay-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(110px, 1fr)); gap: 8px; }
.pos3-pay-btn {
  padding: 12px 8px; border-radius: 8px; border: 1px solid var(--border);
  background: var(--surface2); color: var(--text2);
  font-size: 12px; font-weight: 700; cursor: pointer; font-family: inherit;
  text-align: center; transition: all .12s; line-height: 1.4;
}
.pos3-pay-btn:hover   { border-color: var(--accent); color: var(--text); }
.pos3-pay-btn.selected { background: var(--accent); color: #fff; border-color: var(--accent); }

/* montant */
.pos3-amount-row { display: flex; align-items: center; gap: 8px; }
.pos3-currency-lbl { font-size: 13px; font-weight: 700; color: var(--text2); flex-shrink: 0; }
.pos3-change-box {
  display: flex; justify-content: space-between; align-items: center;
  background: var(--surface2); border-radius: 8px; padding: 10px 14px;
  font-size: 13px; font-weight: 700;
}
.pos3-change-box strong { font-size: 16px; font-weight: 800; }

/* montants rapides */
.pos3-quick { display: flex; flex-wrap: wrap; gap: 6px; }
.pos3-quick-btn {
  padding: 6px 10px; border-radius: 6px; font-size: 11px; font-weight: 700; cursor: pointer;
  background: var(--surface2); border: 1px solid var(--border); color: var(--text2);
  font-family: inherit; transition: all .1s;
}
.pos3-quick-btn:hover { border-color: var(--accent); color: var(--text); }
.quick-exact { border-color: var(--green); color: var(--green); }

/* opt danger */
.pos3-opt-danger {
  width: 100%; padding: 12px; border-radius: 8px; text-align: left;
  border: 1px solid color-mix(in srgb, var(--red) 35%, transparent);
  background: color-mix(in srgb, var(--red) 10%, transparent);
  color: var(--red); font-size: 13px; font-weight: 600; cursor: pointer;
  font-family: inherit; display: flex; align-items: center; gap: 8px;
}
.pos3-opt-danger:hover { background: color-mix(in srgb, var(--red) 18%, transparent); }

/* ── Pending warning dialog ── */
.pos3-pending-dialog { max-width: 420px; }
.pos3-pending-body { display: flex; flex-direction: column; gap: 16px; }
.pos3-pending-msg {
  font-size: 13px; color: var(--text2); line-height: 1.6;
  padding: 10px 12px; border-radius: 8px;
  background: color-mix(in srgb, var(--amber) 8%, var(--surface2));
  border-left: 3px solid var(--amber);
}
.pos3-pending-msg strong { color: var(--amber); }
.pos3-pending-actions { display: flex; gap: 10px; }
.pos3-pending-btn {
  flex: 1; display: flex; flex-direction: column; align-items: center; gap: 4px;
  padding: 14px 10px; border-radius: 10px; border: 1px solid var(--border);
  cursor: pointer; font-family: inherit; transition: all .15s;
  background: var(--surface2);
}
.pos3-pending-btn span { font-size: 13px; font-weight: 700; color: var(--text); }
.pos3-pending-btn small { font-size: 10px; color: var(--text3); text-align: center; }
.pos3-pending-btn i { font-size: 22px; margin-bottom: 2px; }
.pos3-pending-pause { border-color: color-mix(in srgb, var(--amber) 40%, var(--border)); }
.pos3-pending-pause i { color: var(--amber); }
.pos3-pending-pause:hover { background: color-mix(in srgb, var(--amber) 10%, var(--surface2)); border-color: var(--amber); }
.pos3-pending-new { border-color: color-mix(in srgb, var(--red) 40%, var(--border)); }
.pos3-pending-new i { color: var(--red); }
.pos3-pending-new:hover { background: color-mix(in srgb, var(--red) 10%, var(--surface2)); border-color: var(--red); }

/* ══ RESPONSIVE ══ */

/* Tablette portrait & petits écrans */
@media (max-width: 900px) {
  .pos3-main { grid-template-columns: 1fr 280px; }
}

/* Mobile (≤ 640px) */
@media (max-width: 640px) {
  .pos3-main { grid-template-columns: 1fr; position: relative; }

  /* Par défaut: articles visibles, commande cachée */
  .pos3-right {
    position: absolute; inset: 0; z-index: 5;
    border-left: none; border-top: 1px solid var(--border);
    transform: translateX(100%); transition: transform .25s ease;
  }
  .pos3-right.mobile-visible { transform: translateX(0); }

  /* Barre du bas */
  .pos3-mobile-bar {
    display: flex; align-items: center; justify-content: space-between;
    padding: 10px 16px; flex-shrink: 0;
    background: var(--surface); border-top: 1px solid var(--border);
  }
  .pos3-mobile-total { font-size: 13px; font-weight: 700; color: var(--text); display: flex; gap: 6px; align-items: center; }
  .pos3-mobile-toggle {
    position: relative; padding: 8px 16px; border-radius: 8px;
    background: var(--accent); border: none; color: #fff;
    font-size: 13px; font-weight: 700; cursor: pointer; font-family: inherit;
    display: flex; align-items: center; gap: 6px;
  }
  .pos3-mb-badge {
    background: var(--red); color: #fff; border-radius: 50%;
    width: 16px; height: 16px; font-size: 9px; font-weight: 800;
    display: flex; align-items: center; justify-content: center;
  }

  /* Grille articles plus compacte */
  .pos3-items-grid { grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); }

  /* FAB en bas à droite, au-dessus de la barre */
  .pos3-fab-group { bottom: 70px; right: 16px; }

  /* Toolbar compact */
  .pos3-toolbar { gap: 6px; padding: 6px 10px; }
  .pos3-search { font-size: 12px; }

  /* Modals plein écran bas */
  .pos3-modal, .pos3-modal-lg {
    width: 100%; max-height: 85dvh;
    border-radius: 16px 16px 0 0; align-self: flex-end;
  }
  .pos3-modal-overlay { align-items: flex-end; padding: 0; }
}

/* POS / très grande largeur */
@media (min-width: 1280px) {
  .pos3-main { grid-template-columns: 1fr 360px; }
  .pos3-items-grid { grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); }
}
</style>
